/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
  useRef,
} from 'react';
import { useTable } from 'react-table';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleDoubleLeft,
  faAngleLeft,
  faAngleDoubleRight,
  faFileExcel,
  faAngleRight,
  faUpload,
  faCheck,
  faClose,
} from '@fortawesome/free-solid-svg-icons';
import './HnlManualIndenting.scss';
import TabList from 'react-tabs/lib/components/TabList';
import { ToastContainer, toast } from 'react-toastify';
import Tab from 'react-tabs/lib/components/Tab';
import { Tabs } from 'react-tabs';
import TabPanel from 'react-tabs/lib/components/TabPanel';
import Lottie from 'lottie-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';

import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import ApiErrorHandler from '../../utils/ApiErrorHandler';
import {
  getAllHnlDropdownData,
  getHnlPlantCodes,
  fetchManualIndent,
  saveManualIndent,
  updateManualIndent,
  exportRegionalHeadManualIndent,
  uploadManualIndentsExcel,
} from '../../store/modules/product/actions';
import {
  selectIsLoading,
  // selectHnLPlantCode,
  selectHnLProduct,
  // selectHnLPlantName,
  // selectHnLProductCategory,
  // selectHnlMaterialCode,
  // selectMaterialDescription,
} from '../../store/modules/product/selectors';
import LoadingModal from '../../components/LoadingModal';
import EmptyInventory from '../../assets/animations/EmptyInventory.json';
import AddProductModal from '../../components/AddProductModal';
import BulkUploadModal from '../../components/BulkUploadModal';
// import { text } from '@fortawesome/fontawesome-svg-core';

const HNL_REPORT_EMAILS = [
  'l1@heritagenutrivet.in',
  'hnllogistics@heritagenutrivet.in',
  'shantanu.deshkar@heritagenutrivet.in',
  'l7@heritagenutrivet.in',
  'l5@heritagenutrivet.in',
  'l3@heritagenutrivet.in',
];

const HnlInputCell = React.memo(
  ({
    type,
    field,
    rowKey,
    initialValue,
    draftValuesRef,
    inputRefs,
    onDraftBlur,
    max,
    required,
    disabled,
  }) => {
    const inputKey = `${field}-${rowKey}`;

    const handleChange = (e) => {
      const draftValues = draftValuesRef.current;
      if (!draftValues[field]) draftValues[field] = {};
      draftValues[field][rowKey] = e.target.value;
    };

    const handleBlur = (e) => {
      onDraftBlur(field, rowKey, e.target.value);
    };

    return (
      <input
        key={inputKey}
        ref={(el) => {
          const refs = inputRefs.current;
          refs[inputKey] = el;
        }}
        type={type}
        className="form__field"
        defaultValue={initialValue ?? ''}
        max={max}
        onChange={handleChange}
        onBlur={handleBlur}
        required={required}
        disabled={disabled}
      />
    );
  },
);

const HnlTextInputCell = React.memo(
  ({
    field,
    rowKey,
    initialValue,
    draftValuesRef,
    inputRefs,
    onDraftBlur,
    max,
    required,
    disabled,
  }) => (
    <HnlInputCell
      type="text"
      field={field}
      rowKey={rowKey}
      initialValue={initialValue}
      draftValuesRef={draftValuesRef}
      inputRefs={inputRefs}
      onDraftBlur={onDraftBlur}
      max={max}
      required={required}
      disabled={disabled}
    />
  ),
);
const HnlNumberInputCell = React.memo(
  ({
    field,
    rowKey,
    initialValue,
    draftValuesRef,
    inputRefs,
    onDraftBlur,
    max,
    required,
    disabled,
  }) => (
    <HnlInputCell
      type="number"
      field={field}
      rowKey={rowKey}
      initialValue={initialValue}
      draftValuesRef={draftValuesRef}
      inputRefs={inputRefs}
      onDraftBlur={onDraftBlur}
      max={max}
      required={required}
      disabled={disabled}
    />
  ),
);
const HnlDateInputCell = React.memo(
  ({
    field,
    rowKey,
    initialValue,
    draftValuesRef,
    inputRefs,
    onDraftBlur,
    max,
    required,
    disabled,
  }) => (
    <HnlInputCell
      type="date"
      field={field}
      rowKey={rowKey}
      initialValue={initialValue}
      draftValuesRef={draftValuesRef}
      inputRefs={inputRefs}
      onDraftBlur={onDraftBlur}
      max={max}
      required={required}
      disabled={disabled}
    />
  ),
);

const normalizeFilterValues = (value) => (Array.isArray(value) ? value.filter(Boolean) : value ? [value] : []);

const joinFilterValues = (value) => normalizeFilterValues(value).join(', ');

const HnlFilterMultiSelect = React.memo(
  ({
    label, value, options, onChange, formatOption = (item) => item,
  }) => {
    const selectedValues = normalizeFilterValues(value);
    const [draftValues, setDraftValues] = useState(selectedValues);
    const detailsRef = useRef(null);
    const safeOptions = Array.isArray(options) ? options.filter(Boolean) : [];

    useEffect(() => {
      setDraftValues(selectedValues);
    }, [value]);

    const toggleValue = (item) => {
      if (draftValues.includes(item)) {
        setDraftValues(draftValues.filter((selected) => selected !== item));
      } else {
        setDraftValues([...draftValues, item]);
      }
    };

    const closeDropdown = () => {
      if (detailsRef.current) detailsRef.current.open = false;
    };

    const handleApply = () => {
      onChange(draftValues);
      closeDropdown();
    };

    const handleCancel = () => {
      setDraftValues(selectedValues);
      closeDropdown();
    };

    return (
      <div className="select-container">
        {label && <span>{label}</span>}
        <details className="hnl-filter-select" ref={detailsRef}>
          <summary>
            {selectedValues.length > 0
              ? `${selectedValues.length} selected`
              : 'Choose here'}
          </summary>
          <div className="hnl-filter-select__menu">
            {safeOptions.map((item, index) => (
              <label
                key={`${item}-${index.toString()}`}
                className="hnl-filter-select__option"
              >
                <input
                  type="checkbox"
                  checked={draftValues.includes(item)}
                  onChange={() => toggleValue(item)}
                />
                <span>{formatOption(item)}</span>
              </label>
            ))}
            {safeOptions.length === 0 && (
              <div className="hnl-filter-select__empty">No options</div>
            )}
            <div className="hnl-filter-select__actions">
              <button
                type="button"
                className="hnl-filter-select__cancel"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                type="button"
                className="hnl-filter-select__apply"
                onClick={handleApply}
              >
                Apply
              </button>
            </div>
          </div>
        </details>
      </div>
    );
  },
);

const Tickets = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => selectHnLProduct(state));
  const userRole = localStorage?.getItem('role');
  const currentUserEmail = (localStorage?.getItem('email') || '')
    .trim()
    .toLowerCase();
  const [tabIndex, setTabIndex] = useState(0);
  const [requireDate, setRequireDate] = useState({});
  const [orderQuantity, setOrderQuantity] = useState({});
  const [dispatchQuantity, setDispatchQuantity] = useState({});
  const [dispatchDate, setDispatchDate] = useState({});
  const [vehicleNumber, setVehicleNumber] = useState({});
  const [approvedQty, setApprovedQty] = useState({});
  const [vehicleCapacity, setVehicleCapacity] = useState({});
  const [expandedRows, setExpandedRows] = useState({});
  const inputRefs = useRef({});
  const hnlInputRefs = useRef({});
  const hnlDraftValuesRef = useRef({});
  const hnlDraftTimersRef = useRef({});
  const fileInputRef = useRef(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [plantCode, setPlantCode] = useState([]);
  const [plantName, setPlantName] = useState([]);
  const [productCategory, setProductCategory] = useState([]);
  const [materialCode, setMaterialCode] = useState([]);
  const [materialDescription, setMaterialDescription] = useState([]);
  const [plantCodeOptions, setPlantCodeOptions] = useState([]);
  const [plantNameOptions, setPlantNameOptions] = useState([]);
  const [plantMapping, setPlantMapping] = useState({});
  const [selectedFullRows, setSelectedFullRows] = useState([]);
  const [lastPlantSelection, setLastPlantSelection] = useState('');
  const [productCategoryOptions, setProductCategoryOptions] = useState([]);
  const [materialCodeOptions, setMaterialCodeOptions] = useState([]);
  const [materialDescriptionOptions, setMaterialDescriptionOptions] = useState(
    [],
  );

  // States for submitted order filter dropdown
  const [submittedPlantCode, setSubmittedPlantCode] = useState([]);
  const [, setSubmittedPlantCodeOption] = useState([]);
  // Add complete options state
  const [
    completeSubmittedPlantCodeOption,
    setCompleteSubmittedPlantCodeOption,
  ] = useState([]);
  const [
    completeSubmittedPlantNameOption,
    setCompleteSubmittedPlantNameOption,
  ] = useState([]);
  const [
    completeSubmittedProductCategoryOption,
    setCompleteSubmittedProductCategoryOption,
  ] = useState([]);
  const [
    completeSubmittedProductNameOption,
    setCompleteSubmittedProductNameOption,
  ] = useState([]);
  const [
    completeSubmittedMaterialCodeOption,
    setCompleteSubmittedMaterialCodeOption,
  ] = useState([]);
  const [
    completeSubmittedRequiredDateOption,
    setCompleteSubmittedRequiredDateOption,
  ] = useState([]);
  const [
    completeSubmittedOrderDateOption,
    setCompleteSubmittedOrderDateOption,
  ] = useState([]);
  const [submittedPlantName, setSubmittedPlantName] = useState([]);
  const [, setSubmittedPlantNameOption] = useState([]);
  const [submittedProductCategory, setSubmittedProductCategory] = useState([]);
  const [, setSubmittedProductCategoryOption] = useState([]);
  const [submittedProductName, setSubmittedProductName] = useState([]);
  const [, setSubmittedProductNameOption] = useState([]);
  useEffect(() => {
    // console.log(completeSubmittedMaterialCodeOption);
  }, [completeSubmittedMaterialCodeOption]);
  const [submittedMaterialCode, setSubmittedMaterialCode] = useState([]);
  const [, setSubmittedMaterialCodeOption] = useState([]);
  const [submittedRequiredDate, setSubmittedRequiredDate] = useState([]);
  const [, setSubmittedRequiredDateOption] = useState([]);
  // Add submitted order date state
  const [submittedOrderDate, setSubmittedOrderDate] = useState([]);
  const [, setSubmittedOrderDateOption] = useState([]);
  const [submittedSortBy, setSubmittedSortBy] = useState('latest');
  // console.log('submittedOrderDateOption', submittedOrderDateOption);
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState([]);
  const [storePageSizeValue, setStorePageSizeValue] = useState(30);
  const [pageNum, setPageNum] = useState(1);
  const dynamicAccessorUom = userRole === 'regional_pi' ? 'kgsOrLtrs' : 'uom';
  const dynamicOrderQuantity = userRole === 'regional_pi' ? 'orderQuantity' : 'orderedQuantity';
  const minDate = new Date();
  minDate.setDate(minDate.getDate() + 1);
  const formattedMinDate = minDate.toISOString().split('T')[0];
  const formatDate = (date) => {
    if (!date) return '';
    const datePart = String(date).split('T')[0];
    const ddMmYyyyMatch = datePart.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
    if (ddMmYyyyMatch) {
      const [, day, month, year] = ddMmYyyyMatch;
      return `${day}-${month}-${year}`;
    }

    const yyyyMmDdMatch = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (yyyyMmDdMatch) {
      const [, year, month, day] = yyyyMmDdMatch;
      return `${day}-${month}-${year}`;
    }

    const parsedDate = new Date(date);
    if (Number.isNaN(parsedDate.getTime())) {
      return typeof date === 'string' ? date : '';
    }
    const day = String(parsedDate.getDate()).padStart(2, '0');
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const year = parsedDate.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const formatDateForInput = (date) => {
    if (!date) return '';

    const datePart = String(date).split('T')[0];
    const ddMmYyyyMatch = datePart.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
    if (ddMmYyyyMatch) {
      const [, day, month, year] = ddMmYyyyMatch;
      return `${year}-${month}-${day}`;
    }

    const yyyyMmDdMatch = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (yyyyMmDdMatch) return datePart;

    const parsedDate = new Date(date);
    if (Number.isNaN(parsedDate.getTime())) return '';

    const day = String(parsedDate.getDate()).padStart(2, '0');
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const year = parsedDate.getFullYear();
    return `${year}-${month}-${day}`;
  };
  const getMetricTonneValue = (item) => {
    const productType = String(
      item?.feedType || item?.productCategory || '',
    ).toLowerCase();
    if (productType !== 'feed') return '-';

    const uomValue = Number(
      String(item?.uom ?? item?.kgsOrLtrs ?? '').replace(/[^0-9.-]/g, ''),
    );
    const quantityValue = Number(
      item?.orderedQuantity ?? item?.orderQuantity ?? item?.indentQuantity,
    );
    if (!Number.isFinite(uomValue) || !Number.isFinite(quantityValue)) return '-';

    const metricTonne = (uomValue * quantityValue) / 1000;
    return Number.isInteger(metricTonne) ? metricTonne : metricTonne.toFixed(3);
  };
  const getManualIndentRowKey = (item) => item?.rowKey || item?.id;
  const getTodayDateInputValue = () => new Date().toISOString().slice(0, 10);
  const isFutureDate = (value) => value && value > getTodayDateInputValue();
  const isManualIndentUpdateSuccess = (response) => response?.success !== false;
  const getManualIndentUpdateErrorMessage = (response) => response?.message
    || response?.data?.message
    || 'Failed to update indent. Please try again.';
  const isHnlAdmin = userRole === 'hnl-admin';
  const canEditHnlIndents = isHnlAdmin
    && HNL_REPORT_EMAILS.includes(currentUserEmail);
  const orderedTabIndex = 1;
  const partialApprovedTabIndex = 2;
  const dispatchedHistoryTabIndex = 3;
  const isHnlApprovalTab = isHnlAdmin && tabIndex === 0;
  const isHnlDispatchTab = isHnlAdmin && tabIndex === orderedTabIndex;
  const isHnlPartialApprovalTab = isHnlAdmin && tabIndex === partialApprovedTabIndex;
  const isHnlDispatchedHistoryTab = isHnlAdmin && tabIndex === dispatchedHistoryTabIndex;
  const isHnlWorkTab = isHnlAdmin
    && (isHnlApprovalTab || isHnlDispatchTab || isHnlPartialApprovalTab);
  const isSubmittedSortView = () => isHnlAdmin
    || (userRole === 'regional_pi' && tabIndex === orderedTabIndex);
  const getCurrentIndentType = () => {
    if (isHnlPartialApprovalTab) return 'partialApprovedIndents';
    if (isHnlDispatchedHistoryTab) return 'dispatchedIndents';
    if (isHnlDispatchTab || tabIndex === orderedTabIndex) return 'orderedIndents';
    return 'orderIndents';
  };
  const getQuantityNumber = (value) => {
    if (value === null || value === undefined || value === '') return 0;
    const quantity = Number(String(value).replace(/[^0-9.-]/g, ''));
    return Number.isFinite(quantity) ? quantity : 0;
  };
  const getBalanceDisplayValue = (value) => {
    if (!Number.isFinite(value)) return 0;
    return Number.isInteger(value) ? value : Number(value.toFixed(3));
  };
  const getManualIndentBalances = (item, overrides = {}) => {
    const rowKey = getManualIndentRowKey(item);
    const hnlStatus = overrides.hnlStatus ?? item?.hnlStatus;
    const orderedQuantity = getQuantityNumber(
      overrides.orderedQuantity ?? item?.orderedQuantity ?? item?.orderQuantity,
    );
    const approvedBatchQty = overrides.approvedQty !== undefined
      ? overrides.approvedQty
      : approvedQty?.[rowKey];
    const dispatchBatchQty = overrides.dispatchQuantity !== undefined
      ? overrides.dispatchQuantity
      : dispatchQuantity?.[rowKey];
    const receivedBatchQty = overrides.receivedQty !== undefined ? overrides.receivedQty : undefined;
    const approvedQuantity = getQuantityNumber(item?.approvedQty)
      + getQuantityNumber(approvedBatchQty);
    const dispatchedQuantity = getQuantityNumber(item?.dispatchQuantity)
      + getQuantityNumber(dispatchBatchQty);
    const receivedQuantity = getQuantityNumber(item?.receivedQty)
      + getQuantityNumber(receivedBatchQty);
    const isRejected = hnlStatus === 'rejected';
    const balanceQuantityToBeApproved = isRejected
      ? 0
      : Math.max(orderedQuantity - approvedQuantity, 0);
    const balanceQuantityToBeDispatched = isRejected
      ? 0
      : Math.max(approvedQuantity - dispatchedQuantity, 0);
    const balanceQuantityToBeReceived = isRejected
      ? 0
      : Math.max(dispatchedQuantity - receivedQuantity, 0);

    return {
      balanceQuantityToBeApproved: getBalanceDisplayValue(
        balanceQuantityToBeApproved,
      ),
      balanceQuantityToBeDispatched: getBalanceDisplayValue(
        balanceQuantityToBeDispatched,
      ),
      balanceQuantityToBeReceived: getBalanceDisplayValue(
        balanceQuantityToBeReceived,
      ),
      partialApproved:
        !isRejected
        && hnlStatus === 'approved'
        && balanceQuantityToBeApproved > 0
        && dispatchedQuantity > 0,
    };
  };
  const getBatchList = (value) => (Array.isArray(value) ? value : []);
  const getReceivedQtyForDispatch = (item, dispatchId) => {
    const receiveBatches = getBatchList(item?.receiveBatches);
    if (
      receiveBatches.length === 0
      && dispatchId === `${item?.id}-legacy-dispatch`
    ) {
      return getQuantityNumber(item?.receivedQty);
    }
    return receiveBatches
      .filter((batch) => batch.dispatchId === dispatchId)
      .reduce((total, batch) => total + getQuantityNumber(batch.qty), 0);
  };
  const getReceivedRemarks = (item) => [
    ...new Set(
      getBatchList(item?.receiveBatches)
        .map((batch) => batch.remarks)
        .filter(Boolean),
    ),
  ].join(', ');
  const getDispatchBatchOptions = (item) => {
    const batches = getBatchList(item?.dispatchBatches);
    if (batches.length > 0) return batches;
    if (getQuantityNumber(item?.dispatchQuantity) > 0) {
      return [
        {
          dispatchId: `${item?.id}-legacy-dispatch`,
          qty: item.dispatchQuantity,
          date: item.dispatchDate,
          vehicleNo: item.vehicleNumber,
          vehicleCapacity: item.vehicleCapacity,
        },
      ];
    }
    return [];
  };
  const getReceivableDispatchBatchOptions = (item) => {
    const receivedDispatchIds = new Set(
      getBatchList(item?.receiveBatches)
        .map((batch) => batch.dispatchId)
        .filter(Boolean),
    );
    if (receivedDispatchIds.size === 0 && getQuantityNumber(item?.receivedQty) > 0) {
      receivedDispatchIds.add(`${item?.id}-legacy-dispatch`);
    }

    const groupedDispatches = getDispatchBatchOptions(item).reduce((groups, batch) => {
      const { dispatchId } = batch;
      if (!dispatchId || receivedDispatchIds.has(dispatchId)) return groups;
      const current = groups[dispatchId] || {
        ...batch,
        qty: 0,
        dispatchCount: 0,
      };
      return {
        ...groups,
        [dispatchId]: {
          ...current,
          qty: current.qty + getQuantityNumber(batch.qty),
          dispatchCount: current.dispatchCount + 1,
          date: batch.date || current.date,
          vehicleNo: batch.vehicleNo || current.vehicleNo,
        },
      };
    }, {});

    return Object.values(groupedDispatches);
  };
  const hasBatchHistory = (item) => getBatchList(item?.approvalBatches).length > 0
    || getBatchList(item?.dispatchBatches).length > 0
    || getBatchList(item?.receiveBatches).length > 0;
  const roles = ['regional_pi', 'hnl-admin', 'admin'];

  // Add order date state
  const [orderDate, setOrderDate] = useState([]);
  const [orderDateOptions, setOrderDateOptions] = useState([]);

  // Required date filter for tab 0 (non-regional_pi roles)
  const [requiredDateFilter, setRequiredDateFilter] = useState([]);
  const [requiredDateFilterOptions, setRequiredDateFilterOptions] = useState(
    [],
  );

  // Region name filter for hnl-admin on tab 0
  const [regionNameFilter, setRegionNameFilter] = useState([]);
  const [regionNameFilterOptions, setRegionNameFilterOptions] = useState([]);

  const toFilterParam = (value) => normalizeFilterValues(value).join(',');
  const getFilterEntry = (key, value) => {
    const filterValue = toFilterParam(value);
    return filterValue ? { [key]: filterValue } : {};
  };
  const getActiveFilterState = () => (tabIndex === orderedTabIndex || isHnlDispatchedHistoryTab
    ? {
      regionName: regionNameFilter,
      plantCode: submittedPlantCode,
      plantName: submittedPlantName,
      productCategory: submittedProductCategory,
      productName: submittedProductName,
      materialCode: submittedMaterialCode,
      materialDescription: submittedProductName,
      requiredDate: submittedRequiredDate,
      orderedDate: submittedOrderDate,
    }
    : {
      regionName: regionNameFilter,
      plantCode,
      plantName,
      productCategory,
      materialCode,
      materialDescription,
      requiredDate: requiredDateFilter,
      orderedDate: orderDate,
    });
  const getCurrentFilterPayload = () => {
    const payload = {
      type: getCurrentIndentType(),
      page: pageNum,
      limit: storePageSizeValue,
    };
    if (isSubmittedSortView()) payload.sortby = submittedSortBy;
    const filters = getActiveFilterState();
    return Object.keys(filters).reduce(
      (nextPayload, key) => ({
        ...nextPayload,
        ...getFilterEntry(key, filters[key]),
      }),
      payload,
    );
  };
  const buildHnlFilters = (overrides = {}) => {
    const filters = { ...getActiveFilterState(), ...overrides };
    return Object.keys(filters).reduce(
      (payload, key) => ({
        ...payload,
        ...getFilterEntry(key, filters[key]),
      }),
      {},
    );
  };

  const fetchDropdownData = async (filters = {}) => {
    try {
      setLoading(true);
      const dd = await dispatch(
        getAllHnlDropdownData(getCurrentIndentType(), filters),
      );
      if (dd) {
        if (dd.dropdownPlantCodes) setPlantCodeOptions(dd.dropdownPlantCodes);
        if (dd.dropdownPlantNames) setPlantNameOptions(dd.dropdownPlantNames);
        if (dd.dropdownProductCategories) setProductCategoryOptions(dd.dropdownProductCategories);
        if (dd.dropdownMaterialCodes) setMaterialCodeOptions(dd.dropdownMaterialCodes);
        if (dd.dropdownMaterialDescriptions) setMaterialDescriptionOptions(dd.dropdownMaterialDescriptions);
        if (dd.dropdownOrderedDates) setOrderDateOptions(dd.dropdownOrderedDates);
        if (dd.dropdownRequiredDates) setRequiredDateFilterOptions(dd.dropdownRequiredDates);
        if (dd.dropdownRegionNames) setRegionNameFilterOptions(dd.dropdownRegionNames);

        // Build code↔name mapping from parallel arrays (same index = same plant)
        const mapping = {};
        (dd.dropdownPlantCodes || []).forEach((code, i) => {
          const name = (dd.dropdownPlantNames || [])[i];
          if (name) {
            mapping[code] = name;
            mapping[name] = code;
          }
        });
        setPlantMapping(mapping);
      }
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (roles?.includes(userRole)) {
      fetchDropdownData();
    }
  }, [tabIndex]);
  const clearAllFilters = () => {
    setRegionNameFilter([]);
    setPlantCode([]);
    setPlantName([]);
    setProductCategory([]);
    setMaterialCode([]);
    setMaterialDescription([]);
    setRequiredDateFilter([]);
    setOrderDate([]);
    setSubmittedPlantCode([]);
    setSubmittedPlantName([]);
    setSubmittedProductCategory([]);
    setSubmittedProductName([]);
    setSubmittedMaterialCode([]);
    setSubmittedRequiredDate([]);
    setSubmittedOrderDate([]);
    setSubmittedSortBy('latest');
    setLastPlantSelection('');
    setPageNum(1);
  };
  const handleTabClick = (index) => {
    if (index === tabIndex) return;
    clearAllFilters();
    setTabIndex(index);
    setProduct([]);
  };
  const fetchProducts = async () => {
    try {
      setLoading(true);
      const payload = getCurrentFilterPayload();
      const response = await dispatch(fetchManualIndent(payload));
      if (response) {
        const sortedProducts = [...response];
        if (payload.sortby === 'orderId') {
          sortedProducts.sort((a, b) => b.id - a.id);
        } else if (payload.sortby === 'latest') {
          sortedProducts.sort(
            (a, b) => new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0),
          );
        }
        setProduct(sortedProducts);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      toast.error('Failed to fetch products. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line max-len
  }, [
    dispatch,
    tabIndex,
    pageNum,
    storePageSizeValue,
    plantCode,
    plantName,
    productCategory,
    materialCode,
    materialDescription,
    orderDate,
    regionNameFilter,
    requiredDateFilter,
    submittedPlantCode,
    submittedPlantName,
    submittedProductCategory,
    submittedProductName,
    submittedMaterialCode,
    submittedRequiredDate,
    submittedOrderDate,
    submittedSortBy,
  ]);
  const handleFilterChange = (setter, key) => (values) => {
    setter(values);
    setPageNum(1);
    fetchDropdownData(buildHnlFilters({ [key]: values }));
  };
  // const handleSubmittedProductCategory = (selectedProductCategory) => {
  //   setSubmittedMaterialCode('');
  //   setSubmittedPlantCode('');
  //   setSubmittedPlantName('');
  //   setSubmittedOrderDate('');
  //   setSubmittedProductName('');
  //   setSubmittedRequiredDate('');
  //   setSubmittedProductCategory(selectedProductCategory);
  //   // const correspondingProductCategory = plantMapping[selectedProductCategory]
  //   // || product.find((item) => item.feedType === selectedProductCategory);
  //   // setSubmittedProductCategory(correspondingProductCategory);
  //   fetchProducts({ submittedProductCategory: selectedProductCategory });
  // };
  // const handleSubmittedProductName = (selectedProductName) => {
  //   setSubmittedMaterialCode('');
  //   setSubmittedPlantCode('');
  //   setSubmittedPlantName('');
  //   setSubmittedOrderDate('');
  //   setSubmittedProductCategory('');
  //   setSubmittedRequiredDate('');
  //   // console.log('selectedProductName', selectedProductName);
  //   setSubmittedProductName(selectedProductName);
  //   // const correspondingProductName = plantMapping[selectedProductName]
  //   //  || product.find((item) => item.materialName === selectedProductName);
  //   // setSubmittedProductName(correspondingProductName);
  //   fetchProducts({ submittedProductName: selectedProductName });
  // };

  // const handleSubmittedMaterialCode = (selectedMaterialCode) => {
  //   setSubmittedMaterialCode(selectedMaterialCode);
  //   const correspondingProductCategory = plantMapping[selectedMaterialCode];
  //   // console.log('correspondi', correspondingProductCategory);
  //   // || product.find((item) => item.materialCode === selectedMaterialCode);
  //   setSubmittedProductCategory(correspondingProductCategory);
  //   fetchProducts({ submittedMaterialCode: selectedMaterialCode });
  // };
  // const handleSubmittedRequiredDate = (selectedRequiredDate) => {
  //   setSubmittedMaterialCode('');
  //   setSubmittedPlantCode('');
  //   setSubmittedPlantName('');
  //   setSubmittedOrderDate('');
  //   setSubmittedProductCategory('');
  //   setSubmittedProductName('');
  //   setSubmittedRequiredDate(selectedRequiredDate);
  //   // const correspondingProductCategory = plantMapping[selectedRequiredDate];
  //   // console.log('correspondi', correspondingProductCategory);
  //   // || product.find((item) => item.materialCode === selectedMaterialCode);
  //   // setSubmittedRequiredDate(correspondingProductCategory);
  //   fetchProducts({ submittedRequiredDate: selectedRequiredDate });
  // };
  // const handleSubmittedOrderDate = (selectedOrderDate) => {
  //   setSubmittedMaterialCode('');
  //   setSubmittedPlantCode('');
  //   setSubmittedPlantName('');
  //   setSubmittedProductCategory('');
  //   setSubmittedProductName('');
  //   setSubmittedOrderDate(selectedOrderDate);
  //   setSubmittedRequiredDate('');
  //   // const correspondingProductCategory = plantMapping[selectedOrderDate];
  //   // || product.find((item) => item.materialCode === selectedMaterialCode);
  //   // setSubmittedOrderDate(correspondingProductCategory);
  //   fetchProducts({ submittedOrderDate: selectedOrderDate });
  // };
  const handleRequireDate = (row, field, value) => {
    const rowKey = getManualIndentRowKey(row.original);
    setRequireDate((prev) => ({
      ...prev,
      [field]: {
        ...prev[field],
        [rowKey]: value,
      },
    }));
  };
  const handleOrderQuantity = (row, field, value) => {
    const rowKey = getManualIndentRowKey(row.original);
    setOrderQuantity((prev) => {
      if (prev[field]?.[rowKey] === value) return prev;
      return {
        ...prev,
        [field]: {
          ...prev[field],
          [rowKey]: value,
        },
      };
    });
    setTimeout(() => {
      if (inputRefs.current[rowKey]) {
        inputRefs.current[rowKey].focus();
      }
    }, 0);
  };
  const getHnlDraftValue = useCallback((field, rowKey, fallback = '') => {
    const draftValue = hnlDraftValuesRef.current?.[field]?.[rowKey];
    return draftValue !== undefined ? draftValue : fallback;
  }, []);
  const syncHnlDraftValue = useCallback((field, rowKey, value) => {
    const setterByField = {
      approvedQty: setApprovedQty,
      dispatchQuantity: setDispatchQuantity,
      dispatchDate: setDispatchDate,
      vehicleNumber: setVehicleNumber,
      vehicleCapacity: setVehicleCapacity,
    };
    const setter = setterByField[field];
    if (!setter) return;
    setter((prev) => {
      if (prev?.[rowKey] === value) return prev;
      return {
        ...prev,
        [rowKey]: value,
      };
    });
  }, []);
  const clearHnlDraftValues = (rowKeys) => {
    const keys = Array.isArray(rowKeys) ? rowKeys : [rowKeys];
    Object.keys(hnlDraftValuesRef.current || {}).forEach((field) => {
      keys.forEach((rowKey) => {
        delete hnlDraftValuesRef.current[field]?.[rowKey];
      });
    });
  };
  const getRemainingApprovalQty = (item) => getManualIndentBalances(item, { approvedQty: 0, dispatchQuantity: 0 })
    .balanceQuantityToBeApproved;
  const getRemainingDispatchQty = (item) => getManualIndentBalances(item, { approvedQty: 0, dispatchQuantity: 0 })
    .balanceQuantityToBeDispatched;
  const isFullDispatchRequired = (item) => getRemainingApprovalQty(item) === 0;
  const getApprovalQtyForSubmit = (item, rowKey) => {
    if (isHnlPartialApprovalTab) return getRemainingApprovalQty(item);
    return getHnlDraftValue('approvedQty', rowKey, approvedQty?.[rowKey] ?? '');
  };
  const getDispatchQtyForSubmit = (item, rowKey) => {
    if (isHnlDispatchTab && isFullDispatchRequired(item)) return getRemainingDispatchQty(item);
    return getHnlDraftValue(
      'dispatchQuantity',
      rowKey,
      dispatchQuantity?.[rowKey] ?? '',
    );
  };
  const getHnlApprovalPayload = (item, hnlStatus, comment) => {
    const rowKey = getManualIndentRowKey(item);
    if (hnlStatus === 'rejected') {
      return {
        id: item.id,
        hnlStatus,
        ...(comment ? { comment } : {}),
      };
    }
    const actionType = isHnlDispatchTab ? 'dispatch' : 'approve';
    const dispatchQuantityValue = actionType === 'dispatch' ? getDispatchQtyForSubmit(item, rowKey) : '';
    const approvedQtyValue = actionType === 'approve' ? getApprovalQtyForSubmit(item, rowKey) : '';
    return {
      id: item.id,
      hnlStatus,
      actionType: hnlStatus === 'approved' ? actionType : undefined,
      ...(actionType === 'dispatch'
        ? {
          dispatchQuantity: dispatchQuantityValue,
          dispatchDate: getHnlDraftValue(
            'dispatchDate',
            rowKey,
            dispatchDate?.[rowKey],
          ),
          vehicleNumber: getHnlDraftValue(
            'vehicleNumber',
            rowKey,
            vehicleNumber?.[rowKey],
          ),
          vehicleCapacity: getHnlDraftValue(
            'vehicleCapacity',
            rowKey,
            vehicleCapacity?.[rowKey],
          ),
        }
        : {
          approvedQty: approvedQtyValue,
        }),
      ...(hnlStatus === 'approved' && actionType === 'approve'
        ? {
          approvedBy: currentUserEmail,
          approvedTime: new Date().toISOString(),
        }
        : {}),
      ...(comment ? { comment } : {}),
    };
  };
  const handleHnlRowStatus = async (item, hnlStatus) => {
    if (!canEditHnlIndents) return;

    const rowKey = getManualIndentRowKey(item);
    const payload = getHnlApprovalPayload(item, hnlStatus);
    if (hnlStatus === 'approved') {
      const approvedQtyValue = getQuantityNumber(payload.approvedQty);
      const dispatchQtyValue = getQuantityNumber(payload.dispatchQuantity);
      const dispatchDateFilled = String(payload.dispatchDate ?? '').trim() !== '';
      const vehicleCapacityFilled = String(payload.vehicleCapacity ?? '').trim() !== '';
      const vehicleNumberFilled = String(payload.vehicleNumber ?? '').trim() !== '';
      if (payload.actionType === 'approve' && approvedQtyValue <= 0) {
        toast.error('Please fill approval quantity.');
        return;
      }
      if (payload.actionType === 'dispatch' && dispatchQtyValue <= 0) {
        toast.error('Please fill dispatch quantity.');
        return;
      }
      if (
        payload.actionType === 'dispatch'
        && (!dispatchDateFilled || !vehicleCapacityFilled || !vehicleNumberFilled)
      ) {
        toast.error(
          'Please fill vehicle capacity, vehicle number and dispatch date for dispatch quantity.',
        );
        return;
      }
      if (
        payload.actionType === 'dispatch'
        && isFutureDate(payload.dispatchDate)
      ) {
        toast.error('Dispatch date cannot be future date.');
        return;
      }
    }

    try {
      if (hnlStatus === 'approved') {
        const confirmActionText = isHnlDispatchTab ? 'dispatch' : 'approve';
        const result = await Swal.fire({
          title: isHnlDispatchTab ? 'Confirm Dispatch?' : 'Confirm Approval?',
          text: `Are you sure you want to ${confirmActionText} ${
            item?.materialName ?? 'this indent'
          }?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#229945',
          cancelButtonColor: '#d33',
        });
        if (!result.isConfirmed) return;
      } else {
        const result = await Swal.fire({
          title: `Why reject ${item?.materialName ?? 'this indent'}?`,
          input: 'textarea',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#229945',
          cancelButtonColor: '#d33',
        });
        if (!result.isConfirmed) return;
        if (!result.value) {
          toast.error('Please enter the reason for rejection.');
          return;
        }
        payload.comment = result.value;
      }

      const response = await dispatch(updateManualIndent([payload]));
      if (!isManualIndentUpdateSuccess(response)) {
        toast.error(getManualIndentUpdateErrorMessage(response));
        return;
      }
      toast(`Indent ${hnlStatus} successfully`);
      clearHnlDraftValues(rowKey);
      await fetchProducts('');
      setDispatchQuantity((prev) => {
        const next = { ...prev };
        delete next[rowKey];
        return next;
      });
      setDispatchDate((prev) => {
        const next = { ...prev };
        delete next[rowKey];
        return next;
      });
      setVehicleNumber((prev) => {
        const next = { ...prev };
        delete next[rowKey];
        return next;
      });
      setApprovedQty((prev) => {
        const next = { ...prev };
        delete next[rowKey];
        return next;
      });
      setVehicleCapacity((prev) => {
        const next = { ...prev };
        delete next[rowKey];
        return next;
      });
    } catch (error) {
      console.error('Error updating indent:', error);
      toast.error('Failed to update indent. Please try again.');
    }
  };
  const handleConfirmDelivery = async (item) => {
    if (userRole !== 'regional_pi') return;
    const dispatchBatchOptions = getReceivableDispatchBatchOptions(item);
    if (dispatchBatchOptions.length === 0) {
      toast.error('No pending dispatch batch to receive.');
      return;
    }
    const autoSelectedDispatchId = dispatchBatchOptions.length === 1
      ? dispatchBatchOptions[0].dispatchId
      : '';
    const dispatchOptionsHtml = dispatchBatchOptions
      .map((batch) => {
        const label = `${batch.dispatchId || ''} | Dispatch: ${batch.qty ?? ''} | Date: ${formatDate(
          batch.date,
        )} | Vehicle: ${batch.vehicleNo || ''}`;
        const selected = batch.dispatchId === autoSelectedDispatchId ? ' selected' : '';
        return `<option value="${
          batch.dispatchId || ''
        }"${selected}>${label}</option>`;
      })
      .join('');
    const result = await Swal.fire({
      title: 'Confirm Material Received',
      html: `
        <div class="received-form">
          <label class="received-form__label" for="swal-dispatchId">Dispatch Batch</label>
          <select id="swal-dispatchId" class="received-form__input">
            ${
  autoSelectedDispatchId
    ? ''
    : '<option value="">Choose dispatch batch</option>'
}
            ${dispatchOptionsHtml}
          </select>
          <label class="received-form__label" for="swal-receivedQty">Received Quantity</label>
          <input id="swal-receivedQty" type="number" class="received-form__input" placeholder="e.g. 600">
          <label class="received-form__label" for="swal-receivedDate">Received Date</label>
          <input id="swal-receivedDate" type="date" class="received-form__input" max="${getTodayDateInputValue()}">
          <label class="received-form__label" for="swal-receivedVehicleNo">Received Vehicle No <span>(optional)</span></label>
          <input id="swal-receivedVehicleNo" type="text" class="received-form__input" placeholder="e.g. AP09AB1234">
          <label class="received-form__label" for="swal-receivedRemarks">Remarks <span>(optional)</span></label>
          <textarea id="swal-receivedRemarks" class="received-form__input received-form__textarea" rows="3" placeholder="Add remarks"></textarea>
        </div>
      `,
      icon: undefined,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      confirmButtonColor: '#229945',
      cancelButtonColor: '#dc3545',
      customClass: {
        popup: 'received-modal',
      },
      preConfirm: () => {
        const dispatchId = document.getElementById('swal-dispatchId').value;
        const receivedQty = document.getElementById('swal-receivedQty').value;
        const receivedDate = document.getElementById('swal-receivedDate').value;
        const receivedVehicleNo = document.getElementById(
          'swal-receivedVehicleNo',
        ).value;
        const receivedRemarks = document.getElementById(
          'swal-receivedRemarks',
        ).value;
        const receivedQtyValue = Number(receivedQty);
        if (!dispatchId) {
          Swal.showValidationMessage('Dispatch batch is required.');
          return false;
        }
        if (
          receivedQty === ''
          || Number.isNaN(receivedQtyValue)
          || receivedQtyValue < 0
        ) {
          Swal.showValidationMessage('Received quantity is required.');
          return false;
        }
        if (receivedQtyValue > 0 && !receivedDate) {
          Swal.showValidationMessage('Received date is required.');
          return false;
        }
        if (receivedDate && isFutureDate(receivedDate)) {
          Swal.showValidationMessage('Received date cannot be future date.');
          return false;
        }
        return {
          dispatchId,
          receivedQty,
          receivedDate,
          receivedVehicleNo,
          receivedRemarks,
        };
      },
    });
    if (!result.isConfirmed || !result.value) return;

    try {
      const balances = getManualIndentBalances(item, {
        receivedQty: result.value.receivedQty,
      });
      const response = await dispatch(
        updateManualIndent([
          {
            id: item.id,
            actionType: 'receive',
            dispatchId: result.value.dispatchId,
            receivedQty: result.value.receivedQty,
            receivedDate: result.value.receivedDate,
            receivedVehicleNo: result.value.receivedVehicleNo || '',
            receivedRemarks: result.value.receivedRemarks || '',
            balanceQuantityToBeReceived: balances.balanceQuantityToBeReceived,
          },
        ]),
      );
      if (!isManualIndentUpdateSuccess(response)) {
        toast.error(getManualIndentUpdateErrorMessage(response));
        return;
      }
      toast('Delivery confirmed successfully');
      await fetchProducts('');
    } catch (error) {
      console.error('Error confirming delivery:', error);
      toast.error('Failed to confirm delivery. Please try again.');
    }
  };
  const toggleRowSelection = (prev, rowId) => {
    if (prev.includes(rowId)) {
      return prev.filter((id) => id !== rowId);
    }
    return [...prev, rowId];
  };
  const handleCheckboxChange = (row) => {
    const rowKey = getManualIndentRowKey(row.original);
    setSelectedRows((prev) => toggleRowSelection(prev, rowKey));
    setSelectedFullRows((prev) => {
      const isSelected = prev.some((r) => getManualIndentRowKey(r) === rowKey);
      if (isSelected) {
        return prev.filter((r) => getManualIndentRowKey(r) !== rowKey);
      }
      return [...prev, row.original];
    });
  };
  const handleSelectAll = (e) => {
    const { checked } = e.target;
    if (checked) {
      setSelectedRows(product.map((item) => getManualIndentRowKey(item)));
      setSelectedFullRows(product);
    } else {
      setSelectedRows([]);
      setSelectedFullRows([]);
    }
  };
  // Updated showCapacityDifference function with fixed typo
  const showCapacityDifference = async (
    response,
    clusterMap = null,
    delay = 1000,
  ) => {
    setSelectedRows([]);
    const normalize = (c) => String(c).trim().toLowerCase();
    const hasClusterMap = Array.isArray(clusterMap) && clusterMap.length > 0;

    const uniqueClusterKeys = hasClusterMap
      ? Array.from(new Set(clusterMap.filter(Boolean).map(normalize)))
      : [];
    // Parse truck capacity (supports '30 + 10')
    const parseTruckCapacity = (capacity) => {
      if (!capacity) return { total: 0, breakdown: '0', trucks: [] };
      if (typeof capacity === 'number') {
        return {
          total: capacity,
          breakdown: `${capacity}`,
          trucks: [capacity],
        };
      }

      const parts = String(capacity)
        .split('+')
        .map((p) => parseFloat(p.trim()))
        .filter((n) => !Number.isNaN(n));

      const total = parts.reduce((a, b) => a + b, 0);
      return { total, breakdown: parts.join(' + '), trucks: parts };
    };

    const formatTruckMessage = (trucks, total) => {
      if (trucks.length === 1) {
        return `One truck of <b>${trucks[0]} tons</b> is assigned (total <b>${total} tons</b>).`;
      }
      const truckList = trucks
        .map((t) => `one <b>${t}-ton</b> truck`)
        .join(' and ');
      return `${trucks.length} trucks are assigned: ${truckList} (total <b>${total} tons</b>).`;
    };

    const showAlert = (clusterName, status, gap, truckCapacity, totalLoad) => {
      const { total, trucks } = parseTruckCapacity(truckCapacity);
      const truckMsg = formatTruckMessage(trucks, total);

      let title = '';
      let message = '';
      let type = 'success';

      if (status === 'stop') {
        title = `${clusterName} - Action Required`;
        message = `There is <b>${gap} tons</b> of unused capacity. ${truckMsg} Add more items to fully utilize the trucks for dispatch.`;
        type = 'info';
      } else if (status === 'overflow') {
        title = `${clusterName} - Action Required`;
        message = `Could not raise the indent due to exceeding the assigned capacity by <b>${Math.abs(
          gap,
        )} tons</b>! ${truckMsg} Please adjust the quantities accordingly.`;
        type = 'warning';
      } else if (status === 'proceed') {
        title = `${clusterName} - Success`;
        message = `Indent raised successfully for a load of <b>${totalLoad} tons</b>. ${truckMsg}`;
        type = 'success';
      }

      Swal.fire({
        title,
        html: message,
        icon: type,
        confirmButtonColor:
          type === 'warning' || type === 'error' ? '#d33' : '#3085d6',
        confirmButtonText: 'OK',
      });
    };

    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    if (uniqueClusterKeys.length > 0) {
      // eslint-disable-next-line no-restricted-syntax
      for (const key of uniqueClusterKeys) {
        const summaryItem = response.summary.find(
          (item) => item.cluster && item.cluster.toLowerCase() === key,
        );

        if (!summaryItem) {
          toast(`No summary found for cluster: ${key}`, {
            type: toast.TYPE.WARNING,
          });
          // eslint-disable-next-line no-continue
          continue;
        }

        const {
          truckCapacity,
          totalLoad,
          status,
          cluster: displayName,
        } = summaryItem;
        const { total } = parseTruckCapacity(truckCapacity);
        const gap = total - totalLoad;

        showAlert(displayName || key, status, gap, truckCapacity, totalLoad);
        // eslint-disable-next-line no-await-in-loop
        await wait(delay);
      }
    }
  };

  const handleSubmit = async () => {
    if (selectedRows.length === 0) {
      toast.error('Please select at least one product to submit.');
      return;
    }
    let selectedData = product.filter((item) => selectedRows.includes(getManualIndentRowKey(item)));
    console.log('selectedData', selectedData);
    if (selectedData.length !== selectedRows.length) {
      selectedData = selectedFullRows;
    }
    const allFieldsValid = selectedData.every((item) => {
      const isRegionHead = userRole === 'regional_pi';
      const isHnlAdminRole = userRole === 'hnl-admin';
      const rowKey = getManualIndentRowKey(item);
      const requiredDateFilled = !isRegionHead
        || (requireDate?.requiredDate?.[rowKey] !== undefined
          && requireDate?.requiredDate?.[rowKey] !== '');
      const orderQuantityFilled = !isRegionHead
        || (orderQuantity?.orderQuantity?.[rowKey] !== undefined
          && orderQuantity?.orderQuantity?.[rowKey] !== '');
      const approvedQtyDraftValue = getHnlDraftValue(
        'approvedQty',
        rowKey,
        approvedQty?.[rowKey],
      );
      const dispatchQtyDraftValue = getHnlDraftValue(
        'dispatchQuantity',
        rowKey,
        dispatchQuantity?.[rowKey],
      );
      const dispatchDateDraftValue = getHnlDraftValue(
        'dispatchDate',
        rowKey,
        dispatchDate?.[rowKey],
      );
      const vehicleCapacityDraftValue = getHnlDraftValue(
        'vehicleCapacity',
        rowKey,
        vehicleCapacity?.[rowKey],
      );
      const vehicleNumberDraftValue = getHnlDraftValue(
        'vehicleNumber',
        rowKey,
        vehicleNumber?.[rowKey],
      );
      const approvedQtyValue = getQuantityNumber(approvedQtyDraftValue);
      const dispatchQtyValue = getQuantityNumber(
        isHnlDispatchTab && isFullDispatchRequired(item)
          ? getRemainingDispatchQty(item)
          : dispatchQtyDraftValue,
      );
      const hasHnlActionQty = !isHnlAdminRole
        || (isHnlDispatchTab
          ? dispatchQtyValue > 0
          : isHnlPartialApprovalTab
            ? getRemainingApprovalQty(item) > 0
            : approvedQtyValue > 0);
      const dispatchDateFilled = !isHnlAdminRole
        || !isHnlDispatchTab
        || String(dispatchDateDraftValue ?? '').trim() !== '';
      const dispatchDateNotFuture = !isHnlAdminRole
        || !isHnlDispatchTab
        || !isFutureDate(dispatchDateDraftValue);
      const vehicleCapacityFilled = !isHnlAdminRole
        || !isHnlDispatchTab
        || String(vehicleCapacityDraftValue ?? '').trim() !== '';
      const vehicleNumberFilled = !isHnlAdminRole
        || !isHnlDispatchTab
        || String(vehicleNumberDraftValue ?? '').trim() !== '';
      return (
        requiredDateFilled
        && orderQuantityFilled
        && hasHnlActionQty
        && dispatchDateFilled
        && dispatchDateNotFuture
        && vehicleCapacityFilled
        && vehicleNumberFilled
      );
    });

    if (!allFieldsValid) {
      toast.error(
        'Please fill in all the required fields for selected product.',
      );
      return;
    }

    try {
      let response;
      let payload;
      let responseData = null;

      if (userRole === 'regional_pi') {
        payload = selectedData.map((item) => {
          const rowKey = getManualIndentRowKey(item);
          return {
            regionName: item.regionName,
            plantCode: item.plantCode,
            plantName: item.plantName,
            cluster: item.cluster,
            requireDate: formatDate(requireDate?.requiredDate?.[rowKey]),
            feedType: item.feedType,
            materialName: item.materialName,
            materialCode: item.materialCode,
            hnlMaterialCode: item.hnlMaterialCode,
            kgsOrLtrs: item.kgsOrLtrs,
            orderQuantity:
              orderQuantity?.orderQuantity?.[rowKey] ?? item.orderQuantity,
          };
        });

        const cb = (resp) => {
          if (resp && resp.data) {
            responseData = resp.data; // Store for later use
            // console.log('Success response:', resp.data);
            return resp.data;
          }
          console.log('No valid response');
          return null;
        };
        response = await dispatch(saveManualIndent(payload, null, cb));
        console.log('response of Save manual Indent', response);
        if (!response && !responseData) {
          await Swal.fire({
            title: 'Save Failed',
            text:
              'Network error occurred while saving the indent. Please check your connection and try again.',
            icon: 'error',
            confirmButtonColor: '#d33',
          });
          return;
        }
        if (response?.success === false) {
          await Swal.fire({
            title: 'Save Failed',
            text: response?.message || 'Failed to save indent. Please try again.',
            icon: 'error',
            confirmButtonColor: '#d33',
          });
          return;
        }
      } else if (userRole === 'hnl-admin') {
        if (!canEditHnlIndents) {
          toast.error('You do not have permission to perform this action.');
          return;
        }
        payload = selectedData.map((item) => {
          const rowKey = getManualIndentRowKey(item);
          const actionType = isHnlDispatchTab ? 'dispatch' : 'approve';
          const basePayload = {
            id: item.id,
            hnlStatus: 'approved',
            actionType,
          };
          if (actionType === 'dispatch') {
            return {
              ...basePayload,
              dispatchQuantity: getDispatchQtyForSubmit(item, rowKey),
              dispatchDate: getHnlDraftValue(
                'dispatchDate',
                rowKey,
                dispatchDate?.[rowKey],
              ),
              vehicleNumber: getHnlDraftValue(
                'vehicleNumber',
                rowKey,
                vehicleNumber?.[rowKey],
              ),
              vehicleCapacity: getHnlDraftValue(
                'vehicleCapacity',
                rowKey,
                vehicleCapacity?.[rowKey],
              ),
            };
          }
          return {
            ...basePayload,
            approvedQty: getApprovalQtyForSubmit(item, rowKey),
            approvedBy: currentUserEmail,
            approvedTime: new Date().toISOString(),
          };
        });
        response = await dispatch(updateManualIndent(payload));
        if (!isManualIndentUpdateSuccess(response)) {
          toast.error(getManualIndentUpdateErrorMessage(response));
          return;
        }
      } else {
        toast.error('You do not have permission to perform this action.');
        return;
      }

      // Check if response has capacity data to display
      if (responseData?.summary && Array.isArray(responseData.summary)) {
        // Get unique clusters from selected data
        const selectedClusters = [
          ...new Set(
            selectedData
              .map((item) => item.cluster)
              .filter(Boolean)
              .map((cluster) => String(cluster).trim().toLowerCase()),
          ),
        ];

        // Show capacity information using the existing function
        await showCapacityDifference(
          responseData,
          selectedClusters, // clusterMap parameter
        );
      } else {
        // Fallback to simple success message if no capacity data
        toast('Indents saved successfully');
      }

      // Clean up form state
      clearHnlDraftValues(
        selectedData.map((item) => getManualIndentRowKey(item)),
      );
      await fetchProducts('');
      setRequireDate({});
      setOrderQuantity({});
      setDispatchQuantity({});
      setDispatchDate({});
      setVehicleNumber({});
      setApprovedQty({});
      setVehicleCapacity({});
      setSelectedRows([]);
      setPlantCode([]);
      setPlantName([]);
      setProductCategory([]);
      setMaterialCode([]);
      setMaterialDescription([]);
    } catch (error) {
      console.error('Error submitting indent:', error);
      Swal.fire({
        title: 'Save Failed',
        text: ApiErrorHandler.selectMessage(error),
        icon: 'error',
        confirmButtonColor: '#d33',
      });
    }
  };

  const handleExcelUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      // Assuming uploadManualIndentsExcel handles the FormData payload
      dispatch(
        uploadManualIndentsExcel(formData, (response) => {
          if (
            response?.success === false
            || (response?.status && response.status >= 400)
          ) {
            Swal.fire({
              title: 'Upload Failed',
              text:
                response?.message
                || ApiErrorHandler.selectMessage({
                  response: { status: response?.status || 500 },
                }),
              icon: 'error',
              confirmButtonColor: '#d33',
            });
            return;
          }
          const rawUploadedData = Array.isArray(response?.data?.data)
            ? response.data.data
            : Array.isArray(response?.data)
              ? response.data
              : [];
          const uploadedData = rawUploadedData.map((item, index) => ({
            ...item,
            rowKey: [
              item.id,
              item.plantCode,
              item.materialCode,
              item.requiredDate,
              index,
            ]
              .filter(Boolean)
              .join('-'),
          }));

          if (uploadedData.length > 0) {
            setRequireDate((prev) => {
              const next = {
                ...prev,
                requiredDate: { ...(prev.requiredDate || {}) },
              };
              uploadedData.forEach((item) => {
                const rowKey = getManualIndentRowKey(item);
                if (item.requiredDate) {
                  const dateVal = formatDateForInput(item.requiredDate);
                  next.requiredDate[rowKey] = dateVal;
                }
              });
              return next;
            });

            setOrderQuantity((prev) => {
              const next = {
                ...prev,
                orderQuantity: { ...(prev.orderQuantity || {}) },
              };
              uploadedData.forEach((item) => {
                const rowKey = getManualIndentRowKey(item);
                if (item.orderQty !== undefined && item.orderQty !== null) {
                  next.orderQuantity[rowKey] = item.orderQty;
                }
              });
              return next;
            });

            setSelectedRows((prev) => {
              const next = [...prev];
              uploadedData.forEach((item) => {
                const rowKey = getManualIndentRowKey(item);
                if (rowKey && !next.includes(rowKey)) {
                  next.push(rowKey);
                }
              });
              return next;
            });

            setSelectedFullRows((prev) => {
              const next = [...prev];
              uploadedData.forEach((item) => {
                const rowKey = getManualIndentRowKey(item);
                if (
                  rowKey
                  && !next.some((r) => getManualIndentRowKey(r) === rowKey)
                ) {
                  next.push(item);
                }
              });
              return next;
            });
            setProduct(uploadedData); // Display the matching indents on the grid immediately
          } else {
            fetchProducts(); // Refresh products only if no excel rows came back
          }
        }),
      );
      // Reset input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const toggleAddProductModal = () => {
    setShowAddProductModal(!showAddProductModal);
  };
  const exportExcell = () => {
    const type = getCurrentIndentType();
    const flag = 'export';
    const {
      page, limit, type: _type, ...filters
    } = getCurrentFilterPayload();
    dispatch(exportRegionalHeadManualIndent({ type, flag, filters }));
  };

  const toggleBulkUploadModal = () => {
    setShowBulkUploadModal(!showBulkUploadModal);
  };

  const submitAddProduct = (type, values) => {
    const productDetails = {
      plantName: values?.plantName,
      plantCode: values?.plantCode,
      productName: values?.productName,
      materialCode: values?.materialCode,
      productCategory: values?.productCategory,
      uom: values?.uom,
    };
    dispatch(saveManualIndent(type, productDetails));
    fetchProducts();
  };
  const pageSize = Array.from({ length: 10 }, (_, index) => (index + 1) * 30);
  const [selectedPageSize, setSelectedPageSize] = useState(pageSize[0]);
  const handleOnPageSizeSelected = (event) => {
    const newSize = Number(event?.target?.value);
    setSelectedPageSize(newSize);
    setStorePageSizeValue(newSize);
    setPageNum(1);
  };

  const totalRecords = data?.countAllData ?? 0;
  const totalPages = Math.max(
    1,
    Math.ceil(totalRecords / storePageSizeValue) || 1,
  );

  const goToPage = (page) => {
    const safePage = Math.min(Math.max(page, 1), totalPages);
    setPageNum(safePage);
  };

  const nextPage = () => goToPage(pageNum + 1);
  const previousPage = () => goToPage(pageNum - 1);

  const startingSerialNumber = (pageNum - 1) * storePageSizeValue + 1;
  const renderBatchExpandButton = useCallback((item) => {
    const rowKey = getManualIndentRowKey(item);
    if (!hasBatchHistory(item)) return null;
    return (
      <button
        type="button"
        className="batch-expand-btn"
        onClick={() => setExpandedRows((prev) => ({
          ...prev,
          [rowKey]: !prev[rowKey],
        }))}
      >
        {expandedRows[rowKey] ? '-' : '+'}
      </button>
    );
  }, [expandedRows]);

  const columns = useMemo(
    () => [
      {
        Header: 'S.No',
        accessor: 'serialNo',
        Cell: ({ row }) => startingSerialNumber + row.index,
      },
      ...(userRole === 'admin' || userRole === 'hnl-admin'
        ? [
          {
            Header: 'ORDER ID',
            accessor: 'id',
            Cell: ({ row, value }) => (
              <div className="order-id-with-expand">
                {renderBatchExpandButton(row.original)}
                <span>{value}</span>
              </div>
            ),
          },
          {
            Header: () => (
              <HnlFilterMultiSelect
                label="ORDER DATE"
                value={isHnlDispatchTab ? submittedOrderDate : orderDate}
                options={orderDateOptions}
                onChange={handleFilterChange(
                  isHnlDispatchTab ? setSubmittedOrderDate : setOrderDate,
                  'orderedDate',
                )}
                formatOption={formatDate}
              />
            ),
            accessor: 'orderedDate',
            Cell: ({ row }) => (
              <p>{formatDate(row?.original?.createdAt)}</p>
            ),
          },
        ]
        : []),
      {
        Header: () => (userRole === 'hnl-admin' ? (
          <HnlFilterMultiSelect
            label="REGION NAME"
            value={regionNameFilter}
            options={regionNameFilterOptions}
            onChange={handleFilterChange(setRegionNameFilter, 'regionName')}
          />
        ) : (
          'REGION NAME'
        )),
        accessor: 'regionName',
        Cell: ({ value }) => (value !== null ? <p>{value}</p> : ''),
      },
      {
        Header: 'CLUSTER NAME',
        accessor: 'cluster',
        Cell: ({ value }) => (value !== null ? <p>{value}</p> : ''),
      },
      {
        Header: () => (
          <HnlFilterMultiSelect
            label="PLANT CODE"
            value={isHnlDispatchTab ? submittedPlantCode : plantCode}
            options={plantCodeOptions}
            onChange={handleFilterChange(
              isHnlDispatchTab ? setSubmittedPlantCode : setPlantCode,
              'plantCode',
            )}
          />
        ),
        accessor: 'plantCode',
        Cell: ({ row }) => <p>{row?.original?.plantCode}</p>,
      },
      {
        Header: () => (
          <HnlFilterMultiSelect
            label="PLANT NAME"
            value={isHnlDispatchTab ? submittedPlantName : plantName}
            options={plantNameOptions}
            onChange={handleFilterChange(
              isHnlDispatchTab ? setSubmittedPlantName : setPlantName,
              'plantName',
            )}
          />
        ),
        accessor: 'plantName',
        Cell: ({ row }) => <p>{row?.original?.plantName}</p>,
      },
      {
        Header: () => (
          <div className="select-container">
            <span>
              REQUIRED DATE
              {userRole === 'regional_pi' && (
                <span className="required-mark">*</span>
              )}
            </span>
            {userRole !== 'regional_pi' && (
              <HnlFilterMultiSelect
                label=""
                value={isHnlDispatchTab ? submittedRequiredDate : requiredDateFilter}
                options={requiredDateFilterOptions}
                onChange={handleFilterChange(
                  isHnlDispatchTab
                    ? setSubmittedRequiredDate
                    : setRequiredDateFilter,
                  'requiredDate',
                )}
                formatOption={formatDate}
              />
            )}
          </div>
        ),
        accessor: 'requiredDate',
        Cell: ({ row }) => {
          const rowKey = getManualIndentRowKey(row.original);
          return userRole === 'regional_pi' ? (
            <input
              type="date"
              className="form__field"
              value={requireDate?.requiredDate?.[rowKey] || ''}
              onChange={(e) => handleRequireDate(row, 'requiredDate', e.target.value)}
              min={formattedMinDate}
              required
            />
          ) : (
            <p>{formatDate(row?.original?.requiredDate)}</p>
          );
        },
      },
      {
        Header: () => (
          <HnlFilterMultiSelect
            label="PRODUCT CATEGORY"
            value={isHnlDispatchTab
              ? submittedProductCategory
              : productCategory}
            options={productCategoryOptions}
            onChange={handleFilterChange(
              isHnlDispatchTab
                ? setSubmittedProductCategory
                : setProductCategory,
              'productCategory',
            )}
          />
        ),
        accessor: 'feedType',
        Cell: ({ row }) => (
          <p>{row?.original?.feedType || row?.original?.productCategory}</p>
        ),
      },
      {
        Header: () => (
          <HnlFilterMultiSelect
            label="MATERIAL CODE"
            value={isHnlDispatchTab ? submittedMaterialCode : materialCode}
            options={materialCodeOptions}
            onChange={handleFilterChange(
              isHnlDispatchTab ? setSubmittedMaterialCode : setMaterialCode,
              'materialCode',
            )}
          />
        ),
        accessor: 'materialCode',
        Cell: ({ row }) => <p>{row.original?.materialCode}</p>,
      },
      ...(userRole !== 'regional_pi'
        ? [
          {
            Header: 'HNL MATERIAL CODES',
            accessor: 'hnlMaterialCode',
            Cell: ({ row }) => <p>{row.original?.hnlMaterialCode}</p>,
          },
        ]
        : []),
      {
        Header: () => (
          <HnlFilterMultiSelect
            label="MATERIAL DESCRIPTION"
            value={isHnlDispatchTab
              ? submittedProductName
              : materialDescription}
            options={materialDescriptionOptions}
            onChange={handleFilterChange(
              isHnlDispatchTab
                ? setSubmittedProductName
                : setMaterialDescription,
              'materialDescription',
            )}
          />
        ),
        accessor: 'materialName',
        Cell: ({ row }) => <p>{row.original?.materialName}</p>,
      },
      {
        Header: 'UNIT OF MEASUREMENT',
        accessor: dynamicAccessorUom,
        Cell: ({ value }) => (value !== null ? <p>{value}</p> : ''),
      },
      {
        Header: () => (
          <span>
            ORDER QUANTITY ( in bags)
            <span className="required-mark">*</span>
          </span>
        ),
        accessor: dynamicOrderQuantity,
        Cell: ({ row }) => {
          const rowKey = getManualIndentRowKey(row.original);
          return userRole === 'regional_pi' ? (
            <input
              key={rowKey}
              ref={(el) => {
                inputRefs.current[rowKey] = el;
              }}
              type="number"
              className="form__field"
              value={
                orderQuantity?.orderQuantity?.[rowKey]
                ?? row.original.orderQuantity
              }
              onChange={(e) => handleOrderQuantity(row, 'orderQuantity', e.target.value)}
              required
            />
          ) : (
            <p>{row?.original?.orderedQuantity}</p>
          );
        },
      },
      ...(userRole === 'hnl-admin'
        ? [
          {
            Header: 'METRIC TONNE',
            accessor: 'metricTonne',
            Cell: ({ row }) => <p>{getMetricTonneValue(row.original)}</p>,
          },
        ]
        : []),
      ...(userRole === 'hnl-admin'
        ? [
          {
            Header: 'SUGGESTED TRUCK',
            accessor: 'truckCapacity',
            Cell: ({ value }) => (value !== null ? <p>{value}</p> : ''),
          },
          ...(tabIndex !== 0
            ? [
              {
                Header: 'TOTAL APPROVED QTY',
                accessor: 'approvedQty',
                Cell: ({ value }) => <p>{value ?? 0}</p>,
              },
            ]
            : []),
          ...(canEditHnlIndents && (isHnlApprovalTab || isHnlPartialApprovalTab)
            ? [
              {
                Header: () => (
                  <span>
                    APPROVE QTY NOW
                    <span className="required-mark">*</span>
                  </span>
                ),
                accessor: 'approveQtyNow',
                Cell: ({ row }) => {
                  const rowKey = getManualIndentRowKey(row.original);
                  if (isHnlPartialApprovalTab) {
                    return (
                      <input
                        type="number"
                        className="form__field"
                        value={getRemainingApprovalQty(row.original)}
                        readOnly
                        disabled
                      />
                    );
                  }
                  return (
                    <HnlNumberInputCell
                      field="approvedQty"
                      rowKey={rowKey}
                      initialValue={getHnlDraftValue('approvedQty', rowKey)}
                      draftValuesRef={hnlDraftValuesRef}
                      inputRefs={hnlInputRefs}
                      onDraftBlur={syncHnlDraftValue}
                      required
                    />
                  );
                },
              },
              {
                Header: 'BALANCE QUANTITY TO BE APPROVED',
                accessor: 'balanceQuantityToBeApproved',
                Cell: ({ row }) => {
                  const rowKey = getManualIndentRowKey(row.original);
                  return (
                    <p>
                      {isHnlPartialApprovalTab
                        ? 0
                        : getManualIndentBalances(row.original, {
                          approvedQty: getHnlDraftValue(
                            'approvedQty',
                            rowKey,
                          ),
                          dispatchQuantity: 0,
                        }).balanceQuantityToBeApproved}
                    </p>
                  );
                },
              },
            ]
            : []),
          ...(isHnlDispatchTab
            ? [
              {
                Header: 'TOTAL DISPATCHED QTY',
                accessor: 'dispatchQuantity',
                Cell: ({ value }) => <p>{value ?? 0}</p>,
              },
              {
                Header: 'BALANCE QUANTITY TO BE DISPATCHED',
                accessor: 'balanceQuantityToBeDispatched',
                Cell: ({ row }) => {
                  const rowKey = getManualIndentRowKey(row.original);
                  return (
                    <p>
                      {
                            getManualIndentBalances(row.original, {
                              approvedQty: 0,
                              dispatchQuantity: getHnlDraftValue(
                                'dispatchQuantity',
                                rowKey,
                              ),
                            }).balanceQuantityToBeDispatched
                          }
                    </p>
                  );
                },
              },
              ...(canEditHnlIndents
                ? [
                  {
                    Header: () => (
                      <span>
                        DISPATCH QTY NOW
                        <span className="required-mark">*</span>
                      </span>
                    ),
                    accessor: 'dispatchQuantityNow',
                    Cell: ({ row }) => {
                      const rowKey = getManualIndentRowKey(row.original);
                      if (isFullDispatchRequired(row.original)) {
                        return (
                          <input
                            type="number"
                            className="form__field"
                            value={getRemainingDispatchQty(row.original)}
                            readOnly
                            disabled
                          />
                        );
                      }
                      return (
                        <HnlNumberInputCell
                          field="dispatchQuantity"
                          rowKey={rowKey}
                          initialValue={getHnlDraftValue(
                            'dispatchQuantity',
                            rowKey,
                          )}
                          draftValuesRef={hnlDraftValuesRef}
                          inputRefs={hnlInputRefs}
                          onDraftBlur={syncHnlDraftValue}
                          required
                        />
                      );
                    },
                  },
                  {
                    Header: () => (
                      <span>
                        DISPATCH DATE
                        <span className="required-mark">*</span>
                      </span>
                    ),
                    accessor: 'dispatchDate',
                    Cell: ({ row }) => {
                      const rowKey = getManualIndentRowKey(row.original);
                      return (
                        <HnlDateInputCell
                          field="dispatchDate"
                          rowKey={rowKey}
                          initialValue={getHnlDraftValue(
                            'dispatchDate',
                            rowKey,
                          )}
                          draftValuesRef={hnlDraftValuesRef}
                          inputRefs={hnlInputRefs}
                          onDraftBlur={syncHnlDraftValue}
                          max={getTodayDateInputValue()}
                          required
                        />
                      );
                    },
                  },
                  {
                    Header: () => (
                      <span>
                        VEHICLE NUMBER
                        <span className="required-mark">*</span>
                      </span>
                    ),
                    accessor: 'vehicleNumber',
                    Cell: ({ row }) => {
                      const rowKey = getManualIndentRowKey(row.original);
                      return (
                        <HnlTextInputCell
                          field="vehicleNumber"
                          rowKey={rowKey}
                          initialValue={getHnlDraftValue(
                            'vehicleNumber',
                            rowKey,
                          )}
                          draftValuesRef={hnlDraftValuesRef}
                          inputRefs={hnlInputRefs}
                          onDraftBlur={syncHnlDraftValue}
                          required
                        />
                      );
                    },
                  },
                  {
                    Header: () => (
                      <span>
                        VEHICLE CAPACITY
                        <span className="required-mark">*</span>
                      </span>
                    ),
                    accessor: 'vehicleCapacity',
                    Cell: ({ row }) => {
                      const rowKey = getManualIndentRowKey(row.original);
                      return (
                        <HnlTextInputCell
                          field="vehicleCapacity"
                          rowKey={rowKey}
                          initialValue={getHnlDraftValue(
                            'vehicleCapacity',
                            rowKey,
                          )}
                          draftValuesRef={hnlDraftValuesRef}
                          inputRefs={hnlInputRefs}
                          onDraftBlur={syncHnlDraftValue}
                          required
                        />
                      );
                    },
                  },
                ]
                : []),
            ]
            : []),
          ...(tabIndex !== 0 && !isHnlWorkTab
            ? [
              {
                Header: 'TOTAL RECEIVED QTY',
                accessor: 'receivedQty',
                Cell: ({ value }) => <p>{value ?? 0}</p>,
              },
              {
                Header: 'BALANCE QUANTITY TO BE RECEIVED',
                accessor: 'balanceQuantityToBeReceived',
                Cell: ({ row }) => {
                  const rowKey = getManualIndentRowKey(row.original);
                  return (
                    <p>
                      {
                            getManualIndentBalances(row.original, {
                              approvedQty: getHnlDraftValue(
                                'approvedQty',
                                rowKey,
                              ),
                              dispatchQuantity: getHnlDraftValue(
                                'dispatchQuantity',
                                rowKey,
                              ),
                            }).balanceQuantityToBeReceived
                          }
                    </p>
                  );
                },
              },
            ]
            : []),
          ...(canEditHnlIndents
            ? [
              {
                Header: 'ACTION',
                accessor: 'hnlAction',
                Cell: ({ row }) => (
                  <div className="buttons">
                    <button
                      type="button"
                      className="mini-button green"
                      onClick={() => handleHnlRowStatus(row.original, 'approved')}
                    >
                      <FontAwesomeIcon icon={faCheck} />
                    </button>
                    {isHnlApprovalTab && (
                    <button
                      type="button"
                      className="mini-button danger"
                      onClick={() => handleHnlRowStatus(row.original, 'rejected')}
                    >
                      <FontAwesomeIcon icon={faClose} />
                    </button>
                    )}
                  </div>
                ),
              },
            ]
            : []),
        ]
        : []),
      ...(userRole === 'regional_pi' || canEditHnlIndents
        ? [
          {
            Header: (
              <input
                type="checkbox"
                checked={selectedRows.length === product.length}
                onChange={handleSelectAll}
              />
            ),
            accessor: 'select',
            Cell: ({ row }) => {
              const rowKey = getManualIndentRowKey(row.original);
              return (
                <input
                  type="checkbox"
                  checked={selectedRows.includes(rowKey)}
                  onChange={() => handleCheckboxChange(row)}
                />
              );
            },
          },
        ]
        : []),
      ...(userRole === 'admin'
        ? [
          {
            Header: 'RH Status',
            accessor: 'rhStatus',
          },
          {
            Header: 'HNL Status',
            accessor: 'hnlStatus',
          },
        ]
        : []),
    ],
    [
      tabIndex,
      isHnlDispatchTab,
      plantCode,
      plantName,
      plantCodeOptions,
      plantNameOptions,
      plantMapping,
      lastPlantSelection,
      orderDate,
      orderDateOptions,
      productCategory,
      productCategoryOptions,
      materialCode,
      materialCodeOptions,
      materialDescription,
      materialDescriptionOptions,
      requiredDateFilter,
      requiredDateFilterOptions,
      submittedOrderDate,
      submittedPlantCode,
      submittedPlantName,
      submittedProductCategory,
      submittedProductName,
      submittedMaterialCode,
      submittedRequiredDate,
      regionNameFilter,
      regionNameFilterOptions,
      requireDate,
      orderQuantity,
      getHnlDraftValue,
      syncHnlDraftValue,
      selectedRows,
      product,
      pageNum,
      storePageSizeValue,
      userRole,
      canEditHnlIndents,
      startingSerialNumber,
      renderBatchExpandButton,
    ],
  );

  const finishedColumns = useMemo(
    () => [
      {
        Header: 'S.No',
        accessor: 'serialNo',
        Cell: ({ row }) => startingSerialNumber + row.index,
      },
      {
        Header: 'ORDER ID',
        accessor: 'id',
        Cell: ({ row, value }) => (
          <div className="order-id-with-expand">
            {renderBatchExpandButton(row.original)}
            <span>{value}</span>
          </div>
        ),
      },
      {
        Header: () => (
          <HnlFilterMultiSelect
            label="ORDER DATE"
            value={submittedOrderDate}
            options={orderDateOptions}
            onChange={handleFilterChange(setSubmittedOrderDate, 'orderedDate')}
            formatOption={formatDate}
          />
        ),
        accessor: 'orderedDate',
        Cell: ({ row }) => <p>{formatDate(row.original.createdAt)}</p>,
      },
      {
        Header: () => (
          <HnlFilterMultiSelect
            label="REQUIRED DATE"
            value={submittedRequiredDate}
            options={requiredDateFilterOptions}
            onChange={handleFilterChange(
              setSubmittedRequiredDate,
              'requiredDate',
            )}
            formatOption={formatDate}
          />
        ),
        accessor: 'requiredDate',
        Cell: ({ row }) => <p>{formatDate(row.original.requiredDate)}</p>,
      },
      {
        Header: () => (
          <HnlFilterMultiSelect
            label="REGION NAME"
            value={regionNameFilter}
            options={regionNameFilterOptions}
            onChange={handleFilterChange(setRegionNameFilter, 'regionName')}
          />
        ),
        accessor: 'regionName',
      },
      {
        Header: 'CLUSTER NAME',
        accessor: 'cluster',
        Cell: ({ value }) => (value !== null ? <p>{value}</p> : ''),
      },
      {
        Header: () => (
          <HnlFilterMultiSelect
            label="PLANT CODE"
            value={submittedPlantCode}
            options={plantCodeOptions}
            onChange={handleFilterChange(setSubmittedPlantCode, 'plantCode')}
          />
        ),
        accessor: 'plantCode',
        Cell: ({ row }) => <p>{row.original.plantCode}</p>,
      },
      {
        Header: () => (
          <HnlFilterMultiSelect
            label="PLANT NAME"
            value={submittedPlantName}
            options={plantNameOptions}
            onChange={handleFilterChange(setSubmittedPlantName, 'plantName')}
          />
        ),
        accessor: 'plantName',
        Cell: ({ row }) => <p>{row.original.plantName}</p>,
      },
      {
        Header: () => (
          <HnlFilterMultiSelect
            label="PRODUCT CATEGORY"
            value={submittedProductCategory}
            options={productCategoryOptions}
            onChange={handleFilterChange(
              setSubmittedProductCategory,
              'productCategory',
            )}
          />
        ),
        accessor: 'productCategory',
        Cell: ({ row }) => <p>{row.original.productCategory}</p>,
      },
      {
        Header: () => (
          <HnlFilterMultiSelect
            label="MATERIAL DESCRIPTION"
            value={submittedProductName}
            options={materialDescriptionOptions}
            onChange={handleFilterChange(
              setSubmittedProductName,
              'materialDescription',
            )}
          />
        ),
        accessor: 'materialName',
        Cell: ({ row }) => <p>{row.original.materialName}</p>,
      },
      {
        Header: () => (
          <HnlFilterMultiSelect
            label="MATERIAL CODE"
            value={submittedMaterialCode}
            options={materialCodeOptions}
            onChange={handleFilterChange(
              setSubmittedMaterialCode,
              'materialCode',
            )}
          />
        ),
        accessor: 'materialCode',
        Cell: ({ row }) => <p>{row.original.materialCode}</p>,
      },
      ...(userRole !== 'regional_pi'
        ? [
          {
            Header: 'HNL MATERIAL CODES',
            accessor: 'hnlMaterialCode',
            Cell: ({ row }) => <p>{row.original?.hnlMaterialCode}</p>,
          },
        ]
        : []),
      {
        Header: 'UNIT OF MEASUREMENT',
        accessor: 'uom',
      },
      {
        Header: 'Order QUANTITY (in bags)',
        accessor: 'orderedQuantity',
      },
      {
        Header: 'METRIC TONNE',
        accessor: 'metricTonne',
        Cell: ({ row }) => <p>{getMetricTonneValue(row.original)}</p>,
      },
      {
        Header: 'APPROVED QTY',
        accessor: 'approvedQty',
      },
      {
        Header: 'BALANCE QUANTITY TO BE APPROVED',
        accessor: 'balanceQuantityToBeApproved',
        Cell: ({ row }) => (
          <p>
            {row.original.balanceQuantityToBeApproved
              ?? getManualIndentBalances(row.original).balanceQuantityToBeApproved}
          </p>
        ),
      },
      {
        Header: 'VEHICLE CAPACITY',
        accessor: 'vehicleCapacity',
      },
      {
        Header: 'DISPATCH QUANTITY',
        accessor: 'dispatchQuantity',
      },
      {
        Header: 'BALANCE QUANTITY TO BE DISPATCHED',
        accessor: 'balanceQuantityToBeDispatched',
        Cell: ({ row }) => (
          <p>
            {row.original.balanceQuantityToBeDispatched
              ?? getManualIndentBalances(row.original)
                .balanceQuantityToBeDispatched}
          </p>
        ),
      },
      {
        Header: 'DISPATCH DATE',
        accessor: 'dispatchDate',
        Cell: ({ row }) => <p>{formatDate(row.original.dispatchDate)}</p>,
      },
      {
        Header: 'VEHICLE NUMBER',
        accessor: 'vehicleNumber',
      },
      {
        Header: 'APPROVED BY',
        accessor: 'approvedBy',
        Cell: ({ row }) => (
          <p>
            {row.original.approvedBy}
            {row.original.approvedTime && <br />}
            {row.original.approvedTime && formatDate(row.original.approvedTime)}
          </p>
        ),
      },
      {
        Header: 'RH Status',
        accessor: 'rhStatus',
      },
      {
        Header: 'HNL Status',
        accessor: 'hnlStatus',
      },
      {
        Header: 'REJECTED REASON',
        accessor: 'comment',
        Cell: ({ value }) => (value ? <p>{value}</p> : ''),
      },
      {
        Header: 'BALANCE QUANTITY TO BE RECEIVED',
        accessor: 'balanceQuantityToBeReceived',
        Cell: ({ row }) => (
          <p>
            {row.original.balanceQuantityToBeReceived
              ?? getManualIndentBalances(row.original).balanceQuantityToBeReceived}
          </p>
        ),
      },
      ...(userRole === 'regional_pi' || userRole === 'hnl-admin'
        ? [
          {
            Header: 'MATERIAL RECEIVED',
            accessor: 'receivedDate',
            Cell: ({ row }) => {
              const item = row.original;
              if (item.hnlStatus !== 'approved') return '';
              const pendingDispatchBatches = getReceivableDispatchBatchOptions(
                item,
              );
              const canConfirmMore = userRole === 'regional_pi'
                  && pendingDispatchBatches.length > 0;
              const hasReceivedConfirmation = getBatchList(item.receiveBatches).length > 0
                || getQuantityNumber(item.receivedQty) > 0
                || Boolean(item.receivedDate);
              if (hasReceivedConfirmation) {
                const receivedRemarks = getReceivedRemarks(item);
                return (
                  <div className="received-summary">
                    <div className="received-summary__row">
                      <span className="received-summary__label">Qty</span>
                      <span className="received-summary__value">
                        {item.receivedQty ?? 0}
                      </span>
                    </div>
                    {item.receivedDate && (
                    <div className="received-summary__row">
                      <span className="received-summary__label">Date</span>
                      <span className="received-summary__value">
                        {formatDate(item.receivedDate)}
                      </span>
                    </div>
                    )}
                    {item.receivedVehicleNo && (
                    <div className="received-summary__row">
                      <span className="received-summary__label">
                        Vehicle
                      </span>
                      <span className="received-summary__value">
                        {item.receivedVehicleNo}
                      </span>
                    </div>
                    )}
                    {receivedRemarks && (
                    <div className="received-summary__row">
                      <span className="received-summary__label">
                        Remarks
                      </span>
                      <span className="received-summary__value">
                        {receivedRemarks}
                      </span>
                    </div>
                    )}
                    {canConfirmMore && (
                    <button
                      type="button"
                      className="confirm-delivery-btn"
                      onClick={() => handleConfirmDelivery(item)}
                    >
                      Confirm Delivery
                    </button>
                    )}
                  </div>
                );
              }
              if (!canConfirmMore) return '';
              return (
                <button
                  type="button"
                  className="confirm-delivery-btn"
                  onClick={() => handleConfirmDelivery(item)}
                >
                  Confirm Delivery
                </button>
              );
            },
          },
        ]
        : []),
    ],
    [
      regionNameFilter,
      regionNameFilterOptions,
      submittedPlantCode,
      submittedPlantName,
      submittedProductCategory,
      submittedProductName,
      submittedMaterialCode,
      submittedRequiredDate,
      submittedOrderDate,
      plantCodeOptions,
      plantNameOptions,
      productCategoryOptions,
      materialDescriptionOptions,
      materialCodeOptions,
      requiredDateFilterOptions,
      orderDateOptions,
      loading,
      startingSerialNumber,
      userRole,
      renderBatchExpandButton,
    ],
  );

  const isSubmittedFilterTab = tabIndex === orderedTabIndex || isHnlDispatchedHistoryTab;
  const activeFilters = isSubmittedFilterTab
    ? [
      submittedPlantCode.length > 0 && {
        label: 'Plant Code',
        value: joinFilterValues(submittedPlantCode),
      },
      submittedPlantName.length > 0 && {
        label: 'Plant Name',
        value: joinFilterValues(submittedPlantName),
      },
      submittedProductCategory.length > 0 && {
        label: 'Product Category',
        value: joinFilterValues(submittedProductCategory),
      },
      submittedProductName.length > 0 && {
        label: 'Material Description',
        value: joinFilterValues(submittedProductName),
      },
      submittedMaterialCode.length > 0 && {
        label: 'Material Code',
        value: joinFilterValues(submittedMaterialCode),
      },
      submittedRequiredDate.length > 0 && {
        label: 'Required Date',
        value: submittedRequiredDate.map(formatDate).join(', '),
      },
      submittedOrderDate.length > 0 && {
        label: 'Order Date',
        value: submittedOrderDate.map(formatDate).join(', '),
      },
      regionNameFilter.length > 0 && {
        label: 'Region',
        value: joinFilterValues(regionNameFilter),
      },
    ].filter(Boolean)
    : [
      regionNameFilter.length > 0 && {
        label: 'Region',
        value: joinFilterValues(regionNameFilter),
      },
      plantCode.length > 0 && {
        label: 'Plant Code',
        value: joinFilterValues(plantCode),
      },
      plantName.length > 0 && {
        label: 'Plant Name',
        value: joinFilterValues(plantName),
      },
      productCategory.length > 0 && {
        label: 'Product Category',
        value: joinFilterValues(productCategory),
      },
      materialCode.length > 0 && {
        label: 'Material Code',
        value: joinFilterValues(materialCode),
      },
      materialDescription.length > 0 && {
        label: 'Material Description',
        value: joinFilterValues(materialDescription),
      },
      requiredDateFilter.length > 0 && {
        label: 'Required Date',
        value: requiredDateFilter.map(formatDate).join(', '),
      },
      orderDate.length > 0 && {
        label: 'Order Date',
        value: orderDate.map(formatDate).join(', '),
      },
    ].filter(Boolean);

  const resetFilters = () => {
    clearAllFilters();
    fetchDropdownData({});
  };
  const renderSubmittedSortSelect = () => (isSubmittedSortView() ? (
    <div className="table-footer__sort">
      <span>Sort By</span>
      <select
        className="dropdown-menu"
        value={submittedSortBy}
        onChange={(event) => {
          setSubmittedSortBy(event.target.value);
          setPageNum(1);
        }}
      >
        <option value="latest">Latest</option>
        <option value="orderId">Order ID</option>
      </select>
    </div>
  ) : null);
  const renderAppliedFilters = () => (activeFilters.length > 0 ? (
    <div className="row">
      <div className="col-12 col-md-12">
        <div className="applied-filters">
          <span className="applied-filters__label">Filters applied:</span>
          {activeFilters.map((filter) => (
            <span key={filter.label} className="applied-filters__chip">
              <b>{filter.label}</b>
              {': '}
              {filter.value}
            </span>
          ))}
          <button
            type="button"
            className="applied-filters__clear"
            onClick={resetFilters}
          >
            Clear Filters
          </button>
        </div>
      </div>
    </div>
  ) : null);

  const isLoading = useSelector((state) => selectIsLoading(state));
  const renderBatchSection = (title, batches, columnsToRender) => (
    <div className="batch-history__section">
      <div className="batch-history__title">{title}</div>
      {batches.length > 0 ? (
        <table className="batch-history__table">
          <thead>
            <tr>
              {columnsToRender.map((column) => (
                <th key={column.key}>{column.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {batches.map((batch, index) => (
              <tr key={`${batch.dispatchId || title}-${index.toString()}`}>
                {columnsToRender.map((column) => (
                  <td key={column.key}>
                    {column.format
                      ? column.format(batch[column.key], batch)
                      : batch[column.key] || '-'}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="batch-history__empty">No batches</div>
      )}
    </div>
  );
  const renderBatchHistory = (item) => (
    <div className="batch-history">
      {renderBatchSection(
        'Approval Batches',
        getBatchList(item.approvalBatches),
        [
          { key: 'dispatchId', label: 'Dispatch ID' },
          { key: 'qty', label: 'Qty' },
          { key: 'date', label: 'Date', format: (value) => formatDate(value) },
          { key: 'by', label: 'By' },
        ],
      )}
      {renderBatchSection('Dispatch Batches', getDispatchBatchOptions(item), [
        { key: 'dispatchId', label: 'Dispatch ID' },
        { key: 'qty', label: 'Qty' },
        { key: 'date', label: 'Date', format: (value) => formatDate(value) },
        { key: 'vehicleNo', label: 'Vehicle No' },
        { key: 'vehicleCapacity', label: 'Vehicle Capacity' },
      ])}
      {renderBatchSection(
        'Receive Batches',
        getBatchList(item.receiveBatches),
        [
          { key: 'dispatchId', label: 'Dispatch ID' },
          { key: 'qty', label: 'Qty' },
          { key: 'date', label: 'Date', format: (value) => formatDate(value) },
          { key: 'vehicleNo', label: 'Vehicle No' },
          { key: 'remarks', label: 'Remarks' },
        ],
      )}
    </div>
  );

  const { headerGroups, rows, prepareRow } = useTable({
    columns:
      (isHnlAdmin ? isHnlDispatchedHistoryTab : tabIndex === orderedTabIndex)
        ? finishedColumns
        : columns,
    data: product?.length
      ? product.map((item) => ({
        ...item,
      }))
      : [],
  });
  return (
    <div className="hnl-indenting-dashboard">
      <ToastContainer />
      {(tabIndex === 0
        || tabIndex === 1
        || (isHnlAdmin && (tabIndex === 2 || isHnlDispatchedHistoryTab))) && (
        <div className="row">
          <div className="col-12 col-md-12">
            <div className="buttons">
              {tabIndex === 0 && userRole === 'regional_pi' && (
                <>
                  <button
                    type="button"
                    className="button primary"
                    onClick={toggleBulkUploadModal}
                    style={{ marginLeft: '10px' }}
                  >
                    <FontAwesomeIcon icon={faUpload} className="button__icon" />
                    Bulk Upload Indents
                  </button>
                  <button
                    type="button"
                    className="button primary"
                    onClick={toggleAddProductModal}
                  >
                    <FontAwesomeIcon className="button__icon" />
                    + Add Product
                  </button>
                </>
              )}
              {(userRole === 'regional_pi' || userRole === 'hnl-admin') && (
                <>
                  <button
                    type="button"
                    className="button green"
                    onClick={exportExcell}
                  >
                    <FontAwesomeIcon
                      icon={faFileExcel}
                      className="button__icon"
                    />
                    Export
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
      {renderAppliedFilters()}
      <Tabs selectedIndex={tabIndex} onSelect={handleTabClick}>
        <TabList className="row between tab-list">
          <Tab className={isHnlAdmin ? 'col-3 tab' : 'col-6 tab'}>
            <div
              className={`type-card ${tabIndex === 0 ? 'selected' : ''}`}
              onClick={() => handleTabClick(0)}
              role="button"
              tabIndex={0}
            >
              {(() => {
                switch (userRole) {
                  case 'admin':
                    return 'Regional Head Approved Indents';
                  case 'hnl-admin':
                    return 'Orders Received';
                  default:
                    return 'Order Here';
                }
              })()}
            </div>
          </Tab>
          {isHnlAdmin && (
            <Tab className="col-3 tab">
              <div
                className={`type-card ${tabIndex === 1 ? 'selected' : ''}`}
                onClick={() => handleTabClick(1)}
                role="button"
                tabIndex={0}
              >
                Orders to be Dispatched
              </div>
            </Tab>
          )}
          {isHnlAdmin && (
            <Tab className="col-3 tab">
              <div
                className={`type-card ${
                  tabIndex === partialApprovedTabIndex ? 'selected' : ''
                }`}
                onClick={() => handleTabClick(partialApprovedTabIndex)}
                role="button"
                tabIndex={0}
              >
                Partially Approved Orders
              </div>
            </Tab>
          )}
          <Tab className={isHnlAdmin ? 'col-3 tab' : 'col-6 tab'}>
            <div
              className={`type-card ${
                tabIndex
                === (isHnlAdmin ? dispatchedHistoryTabIndex : orderedTabIndex)
                  ? 'selected'
                  : ''
              }`}
              onClick={() => handleTabClick(
                isHnlAdmin ? dispatchedHistoryTabIndex : orderedTabIndex,
              )}
              role="button"
              tabIndex={0}
            >
              {(() => {
                switch (userRole) {
                  case 'admin':
                    return 'HNL Dispatch Indents';
                  case 'hnl-admin':
                    return 'Dispatched Orders';
                  default:
                    return 'Submitted Orders';
                }
              })()}
            </div>
          </Tab>
        </TabList>
        <TabPanel className="order-tab-panel">
          <div className="table-container">
            {product?.length > 0 ? (
              <div className="row">
                <div className="col-12">
                  <div className="table-footer">
                    <div className="row middle">
                      <div className="col-12 col-md-6">
                        <span className="table-footer__title">
                          {startingSerialNumber}
                          {' '}
                          to
                          {' '}
                          {Math.min(pageNum * storePageSizeValue, totalRecords)}
                          {' '}
                          {`of ${totalRecords}`}
                          {' '}
                          {''}
                          <span className="form__label">Page Size : </span>
                          <select
                            onChange={handleOnPageSizeSelected}
                            className="dropdown-menu"
                            value={selectedPageSize}
                          >
                            {pageSize?.map((item, index) => (
                              <option
                                key={index.toString()}
                                value={item}
                                className="dropdown-menu"
                              >
                                {item}
                              </option>
                            ))}
                          </select>
                        </span>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="table-footer__buttons">
                          {renderSubmittedSortSelect()}
                          <button
                            type="button"
                            className="table-footer__button"
                            onClick={() => goToPage(1)}
                            disabled={pageNum <= 1}
                          >
                            <FontAwesomeIcon
                              icon={faAngleDoubleLeft}
                              className="table-footer__button__icon"
                            />
                          </button>
                          <button
                            type="button"
                            className="table-footer__button"
                            onClick={previousPage}
                            disabled={pageNum <= 1}
                          >
                            <FontAwesomeIcon
                              icon={faAngleLeft}
                              className="table-footer__button__iclon"
                            />
                          </button>
                          <div className="table-footer__label">
                            {pageNum}
                            {' / '}
                            {totalPages}
                          </div>
                          <button
                            type="button"
                            className="table-footer__button"
                            onClick={nextPage}
                            disabled={pageNum >= totalPages}
                          >
                            <FontAwesomeIcon
                              icon={faAngleRight}
                              className="table-footer__button__icon"
                            />
                          </button>
                          <button
                            type="button"
                            className="table-footer__button"
                            onClick={() => goToPage(totalPages)}
                            disabled={pageNum >= totalPages}
                          >
                            <FontAwesomeIcon
                              icon={faAngleDoubleRight}
                              className="table-footer__button__icon"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <table className="table table-bordered">
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr key={headerGroup.id}>
                        {headerGroup.headers.map((column) => (
                          <th key={column.id} style={{ fontSize: 12 }}>
                            {column.render('Header')}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody>
                    {rows.map((row) => {
                      prepareRow(row);
                      const rowKey = getManualIndentRowKey(row.original);
                      return (
                        <React.Fragment key={row.id}>
                          <tr>
                            {row.cells.map((cell) => (
                              <td
                                key={cell.column.id}
                                style={{ fontSize: 13, fontWeight: 400 }}
                              >
                                {cell.render('Cell')}
                              </td>
                            ))}
                          </tr>
                          {expandedRows[rowKey] && (
                            <tr className="batch-history-row">
                              <td colSpan={row.cells.length}>
                                {renderBatchHistory(row.original)}
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
                {((userRole === 'regional_pi' && tabIndex === 0)
                  || (canEditHnlIndents && isHnlApprovalTab)) && (
                    <div className="col-12 buttons">
                      <button
                        type="button"
                        onClick={handleSubmit}
                        className="button green"
                      >
                        <FontAwesomeIcon className="button__icon" />
                        Submit
                      </button>
                    </div>
                )}
              </div>
            ) : (
              <div className="row middle h-200">
                <div className="d-flex-col center">
                  <Lottie
                    animationData={EmptyInventory}
                    loop={false}
                    className="noUsersIcon"
                  />
                  <p className="noRecordsFound">No Records Found</p>
                </div>
              </div>
            )}
          </div>
        </TabPanel>
        <TabPanel className="order-tab-panel">
          <div className="table-container">
            {product?.length > 0 ? (
              <div className="row">
                <div className="col-12">
                  <div className="table-footer">
                    <div className="row middle">
                      <div className="col-12 col-md-6">
                        <span className="table-footer__title">
                          {startingSerialNumber}
                          {' '}
                          to
                          {' '}
                          {Math.min(pageNum * storePageSizeValue, totalRecords)}
                          {' '}
                          {`of ${totalRecords}`}
                          {' '}
                          {''}
                          <span className="form__label">Page Size : </span>
                          <select
                            onChange={handleOnPageSizeSelected}
                            className="dropdown-menu"
                            value={selectedPageSize}
                          >
                            {pageSize?.map((item, index) => (
                              <option
                                key={index.toString()}
                                value={item}
                                className="dropdown-menu"
                              >
                                {item}
                              </option>
                            ))}
                          </select>
                        </span>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="table-footer__buttons">
                          {renderSubmittedSortSelect()}
                          <button
                            type="button"
                            className="table-footer__button"
                            onClick={() => goToPage(1)}
                            disabled={pageNum <= 1}
                          >
                            <FontAwesomeIcon
                              icon={faAngleDoubleLeft}
                              className="table-footer__button__icon"
                            />
                          </button>
                          <button
                            type="button"
                            className="table-footer__button"
                            onClick={previousPage}
                            disabled={pageNum <= 1}
                          >
                            <FontAwesomeIcon
                              icon={faAngleLeft}
                              className="table-footer__button__iclon"
                            />
                          </button>
                          <div className="table-footer__label">
                            {pageNum}
                            {' / '}
                            {totalPages}
                          </div>
                          <button
                            type="button"
                            className="table-footer__button"
                            onClick={nextPage}
                            disabled={pageNum >= totalPages}
                          >
                            <FontAwesomeIcon
                              icon={faAngleRight}
                              className="table-footer__button__icon"
                            />
                          </button>
                          <button
                            type="button"
                            className="table-footer__button"
                            onClick={() => goToPage(totalPages)}
                            disabled={pageNum >= totalPages}
                          >
                            <FontAwesomeIcon
                              icon={faAngleDoubleRight}
                              className="table-footer__button__icon"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <table className="table table-bordered">
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr key={headerGroup.id}>
                        {headerGroup.headers.map((column) => (
                          <th key={column.id} style={{ fontSize: 12 }}>
                            {column.render('Header')}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody>
                    {rows.map((row) => {
                      prepareRow(row);
                      const rowKey = getManualIndentRowKey(row.original);
                      return (
                        <React.Fragment key={row.id}>
                          <tr>
                            {row.cells.map((cell) => (
                              <td
                                key={cell.column.id}
                                style={{ fontSize: 13, fontWeight: 400 }}
                              >
                                {cell.render('Cell')}
                              </td>
                            ))}
                          </tr>
                          {expandedRows[rowKey] && (
                            <tr className="batch-history-row">
                              <td colSpan={row.cells.length}>
                                {renderBatchHistory(row.original)}
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                  {isHnlAdmin && tabIndex === 1 && (
                    <div className="buttons">
                      <button
                        type="button"
                        onClick={handleSubmit}
                        className="button green"
                      >
                        <FontAwesomeIcon className="button__icon" />
                        Submit
                      </button>
                    </div>
                  )}
                </table>
              </div>
            ) : (
              <div className="row middle h-200">
                <div className="d-flex-col center">
                  <Lottie
                    animationData={EmptyInventory}
                    loop={false}
                    className="noUsersIcon"
                  />
                  <p className="noRecordsFound">No Records Found</p>
                </div>
              </div>
            )}
          </div>
        </TabPanel>
        {isHnlAdmin && (
          <>
            <TabPanel className="order-tab-panel">
              <div className="table-container">
                {product?.length > 0 ? (
                  <div className="row">
                    <div className="col-12">
                      <div className="table-footer">
                        <div className="row middle">
                          <div className="col-12 col-md-6">
                            <span className="table-footer__title">
                              {startingSerialNumber}
                              {' '}
                              to
                              {' '}
                              {Math.min(
                                pageNum * storePageSizeValue,
                                totalRecords,
                              )}
                              {' '}
                              {`of ${totalRecords}`}
                              {' '}
                              {''}
                              <span className="form__label">Page Size : </span>
                              <select
                                onChange={handleOnPageSizeSelected}
                                className="dropdown-menu"
                                value={selectedPageSize}
                              >
                                {pageSize?.map((item, index) => (
                                  <option
                                    key={index.toString()}
                                    value={item}
                                    className="dropdown-menu"
                                  >
                                    {item}
                                  </option>
                                ))}
                              </select>
                            </span>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="table-footer__buttons">
                              {renderSubmittedSortSelect()}
                              <button
                                type="button"
                                className="table-footer__button"
                                onClick={() => goToPage(1)}
                                disabled={pageNum <= 1}
                              >
                                <FontAwesomeIcon
                                  icon={faAngleDoubleLeft}
                                  className="table-footer__button__icon"
                                />
                              </button>
                              <button
                                type="button"
                                className="table-footer__button"
                                onClick={previousPage}
                                disabled={pageNum <= 1}
                              >
                                <FontAwesomeIcon
                                  icon={faAngleLeft}
                                  className="table-footer__button__iclon"
                                />
                              </button>
                              <div className="table-footer__label">
                                {pageNum}
                                {' / '}
                                {totalPages}
                              </div>
                              <button
                                type="button"
                                className="table-footer__button"
                                onClick={nextPage}
                                disabled={pageNum >= totalPages}
                              >
                                <FontAwesomeIcon
                                  icon={faAngleRight}
                                  className="table-footer__button__icon"
                                />
                              </button>
                              <button
                                type="button"
                                className="table-footer__button"
                                onClick={() => goToPage(totalPages)}
                                disabled={pageNum >= totalPages}
                              >
                                <FontAwesomeIcon
                                  icon={faAngleDoubleRight}
                                  className="table-footer__button__icon"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <table className="table table-bordered">
                      <thead>
                        {headerGroups.map((headerGroup) => (
                          <tr key={headerGroup.id}>
                            {headerGroup.headers.map((column) => (
                              <th key={column.id} style={{ fontSize: 12 }}>
                                {column.render('Header')}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody>
                        {rows.map((row) => {
                          prepareRow(row);
                          const rowKey = getManualIndentRowKey(row.original);
                          return (
                            <React.Fragment key={row.id}>
                              <tr>
                                {row.cells.map((cell) => (
                                  <td
                                    key={cell.column.id}
                                    style={{ fontSize: 13, fontWeight: 400 }}
                                  >
                                    {cell.render('Cell')}
                                  </td>
                                ))}
                              </tr>
                              {expandedRows[rowKey] && (
                                <tr className="batch-history-row">
                                  <td colSpan={row.cells.length}>
                                    {renderBatchHistory(row.original)}
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                      {canEditHnlIndents
                        && tabIndex === partialApprovedTabIndex && (
                        <div className="buttons">
                          <button
                            type="button"
                            onClick={handleSubmit}
                            className="button green"
                          >
                            <FontAwesomeIcon className="button__icon" />
                            Submit
                          </button>
                        </div>
                      )}
                    </table>
                  </div>
                ) : (
                  <div className="row middle h-200">
                    <div className="d-flex-col center">
                      <Lottie
                        animationData={EmptyInventory}
                        loop={false}
                        className="noUsersIcon"
                      />
                      <p className="noRecordsFound">No Records Found</p>
                    </div>
                  </div>
                )}
              </div>
            </TabPanel>
            <TabPanel className="order-tab-panel">
              <div className="table-container">
                {product?.length > 0 ? (
                  <div className="row">
                    <div className="col-12">
                      <div className="table-footer">
                        <div className="row middle">
                          <div className="col-12 col-md-6">
                            <span className="table-footer__title">
                              {startingSerialNumber}
                              {' '}
                              to
                              {' '}
                              {Math.min(
                                pageNum * storePageSizeValue,
                                totalRecords,
                              )}
                              {' '}
                              {`of ${totalRecords}`}
                              {' '}
                              {''}
                              <span className="form__label">Page Size : </span>
                              <select
                                onChange={handleOnPageSizeSelected}
                                className="dropdown-menu"
                                value={selectedPageSize}
                              >
                                {pageSize?.map((item, index) => (
                                  <option
                                    key={index.toString()}
                                    value={item}
                                    className="dropdown-menu"
                                  >
                                    {item}
                                  </option>
                                ))}
                              </select>
                            </span>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="table-footer__buttons">
                              {renderSubmittedSortSelect()}
                              <button
                                type="button"
                                className="table-footer__button"
                                onClick={() => goToPage(1)}
                                disabled={pageNum <= 1}
                              >
                                <FontAwesomeIcon
                                  icon={faAngleDoubleLeft}
                                  className="table-footer__button__icon"
                                />
                              </button>
                              <button
                                type="button"
                                className="table-footer__button"
                                onClick={previousPage}
                                disabled={pageNum <= 1}
                              >
                                <FontAwesomeIcon
                                  icon={faAngleLeft}
                                  className="table-footer__button__iclon"
                                />
                              </button>
                              <div className="table-footer__label">
                                {pageNum}
                                {' / '}
                                {totalPages}
                              </div>
                              <button
                                type="button"
                                className="table-footer__button"
                                onClick={nextPage}
                                disabled={pageNum >= totalPages}
                              >
                                <FontAwesomeIcon
                                  icon={faAngleRight}
                                  className="table-footer__button__icon"
                                />
                              </button>
                              <button
                                type="button"
                                className="table-footer__button"
                                onClick={() => goToPage(totalPages)}
                                disabled={pageNum >= totalPages}
                              >
                                <FontAwesomeIcon
                                  icon={faAngleDoubleRight}
                                  className="table-footer__button__icon"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <table className="table table-bordered">
                      <thead>
                        {headerGroups.map((headerGroup) => (
                          <tr key={headerGroup.id}>
                            {headerGroup.headers.map((column) => (
                              <th key={column.id} style={{ fontSize: 12 }}>
                                {column.render('Header')}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody>
                        {rows.map((row) => {
                          prepareRow(row);
                          const rowKey = getManualIndentRowKey(row.original);
                          return (
                            <React.Fragment key={row.id}>
                              <tr>
                                {row.cells.map((cell) => (
                                  <td
                                    key={cell.column.id}
                                    style={{ fontSize: 13, fontWeight: 400 }}
                                  >
                                    {cell.render('Cell')}
                                  </td>
                                ))}
                              </tr>
                              {expandedRows[rowKey] && (
                                <tr className="batch-history-row">
                                  <td colSpan={row.cells.length}>
                                    {renderBatchHistory(row.original)}
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="row middle h-200">
                    <div className="d-flex-col center">
                      <Lottie
                        animationData={EmptyInventory}
                        loop={false}
                        className="noUsersIcon"
                      />
                      <p className="noRecordsFound">No Records Found</p>
                    </div>
                  </div>
                )}
              </div>
            </TabPanel>
          </>
        )}
      </Tabs>
      <AddProductModal
        show={showAddProductModal}
        toggle={toggleAddProductModal}
        onSubmit={(values) => submitAddProduct('newproduct', values)}
        fetchPlantCodes={fetchDropdownData}
        values={data}
      />
      <BulkUploadModal
        show={showBulkUploadModal}
        toggle={toggleBulkUploadModal}
        handleExcelUpload={handleExcelUpload}
      />
      <LoadingModal show={isLoading} />
    </div>
  );
};
export default Tickets;
